const es_localization = {
    name: "es",
    menus: {
        actividades: "Actividades",
        controles: "Controles",
        planesAccion: "Planes de acción",
        actividadesVencidas: "Act. vencidas",
        actividadesFinalizadas: "Act. finalizadas",
        activosInformacion: "Activos de información",
        calendario: "Calendario",
        cerrarSesion: "Cerrar sesión",
        compromisos: "Compromisos",
        procesos: "Procesos",
        configuraciones: "Configuraciones",
        dashboard: "Dashboard",
        documentos: "Documentos",
        oficios: "Oficios",
        indicadores: "Indicadores",
        eventoRiesgos: "Eventos de riesgo",
        resumenEvalRiesgo: "Resumen eval. riesgo",
        planesAccionRer: "Planes de acción RER",
        mapaCalor: "Mapa de calor",
        miPerfil: "Mi perfil",
        misActividades: "Mis Actividades",
        misControles: "Mis controles",
        misIndicadores: "Mis Indicadores",
        exportacion: "Exportación",
        repProximoVencimiento: "Próximo vencimiento",
        repCumplimiento: "Reporte cumplimiento",
        repDocumento: "Reporte documentos",
        repRiesgos: "Reporte de riesgos",
        repIndicadores: "Reporte de indicadores",
        repOficios: "Reporte de oficios",
        repEventosRiesgos: "Reporte eventos riesgos",
        repHallazgos: "Reporte hallazgos",
        atrasos: "Atrasos",
        repControles: "Reporte controles",
        repPlanesAccion: "Reporte planes de acción",
        repActivos: "Reporte activos",
        reportes: "Reportes",
        riesgos: "Riesgos",
        misRiesgos: "Mis riesgos",
        asignadorOficios: "Asignador Oficios",
        misOficios: "Mis oficios",
        gestorCodigos: "Gestor de códigos",
        reasignaciones: "Reasignaciones",
        informes: "Informes",
        timeReport: "TimeReport",
        timeReportMisReportes: "TimeReport Mis reportes",
        marcaciones: "Marcaciones",
        reportesJornadas: "Reportes de jornadas",
        tareasCortas: "Tareas cortas",
        tareasYAcuerdos: "Tareas y acuerdos",
        misTareasCortas: "Mis tareas cortas",
        misTareasYAcuerdos: "Mis tareas y acuerdos",
        auditoria: "Auditoría",
        proyectos: "Proyectos",
        cumplimiento: "Cumplimiento",
        solicitudesProrroga: "Solicitudes prórroga",
        extras: "Extras",
        solicitudesDocumentos: "Solicitudes documentos",
        assessment: "Evaluaciones",
        misEvaluaciones: "Mis evaluaciones",
        proveedores: "Proveedores",
        modelosEvaluacionProveedores: "Modelos de evaluación",
        evaluacionesProveedores: "Evaluaciones",
        misEvaluacionesProveedores: "Mis evaluaciones",
        misVisacionesProveedores: "Mis visaciones",
        misRevisionesProveedores: "Mis revisiones",
        planesAuditoria: "Planes de auditoría",
        auditorias: "Auditorías",
        misAuditorias: "Mis auditorías",
        misPruebasAuditorias: "Mis pruebas de auditoría",
        misRecomendaciones: "Mis recomendaciones",
        misCompromisos: "Mis compromisos",
        misHorasAuditoria: "Mis horas de auditoría",
        reglasAuditoria: "Reglas de auditoría",
        justifReglas: "Justificaciones reglas",
        repReglas: "Reporte de reglas",
        repAuditoriaInterna: "Reporte auditoría",
        misReglasAuditoria: "Mis reglas auditoría",
        misprorrogasCompromisos: "Mis prórrogas",
        prorrogasPendientes: "Prórrogas pendientes",
        misHallazgos: "Mis hallazgos",
        repAssessment: "Reporte evaluaciones",
        accionesPrevias: "Acciones previas",
        directorio: "Directorio",
        comites: "Comités",
        sesiones: "Sesiones",
        actas: "Actas",
        contratos: "Contratos",
        versionesContratos: "Versiones contratos",
        contratosEnRevision: "Contratos en revisión",
        pagos: "Pagos",
        misContratos: "Mis contratos",
        firmas: "Firmas",
        misFirmas: "Mis firmas",
        repAcuerdos: "Reporte de acuerdos",
        garantias: "Garantías",
        incidencias: "Incidencias",
        repIncidencias: "Reporte de incidencias",
        repContratos: "Reporte de contratos",
        controlesVencidos: "Controles vencidos",
        controlesFinalizados: "Controles finalizados",
        misActPreliminares: "Mis act. preliminares",
        requerimientos: "Requerimientos",
        misRequerimientos: "Mis requerimientos",
        gestorAprobaciones: "Gestor de aprobaciones",
        reporteSolDocumento: "Reporte sol. documento",
        objetivosEstrategicos: "Objetivos estratégicos",
        misObjetivos: "Mis objetivos",
        repObjetivosEstrategicos: "Reporte de objetivos",
    },
    components: {
        sistema: {
            abril: "abril",
            agosto: "agosto",
            agregar: "Agregar",
            agregarNuevoComentario: "Agrega un nuevo comentario",
            cancelar: "Cancelar",
            aceptar: "Aceptar",
            confirmacion: "Confirmación",
            comentario: "Comentario",
            crearComentarioExitoso: "El sistema guardó exitosamente el comentario ingresado",
            descargarAarchivo: "Descargar archivo",
            desde: "Desde",
            diciembre: "diciembre",
            domingo: "domingo",
            elementoNoEncontrado: "Elemento no encontrado.",
            eliminar: "Eliminar",
            enero: "enero",
            febrero: "febrero",
            hasta: "Hasta",
            historial: "Historial",
            historialYcomentarios: "Historial y comentarios",
            jueves: "jueves",
            julio: "julio",
            junio: "junio",
            lunes: "lunes",
            martes: "martes",
            marzo: "marzo",
            mayo: "mayo",
            miercoles: "miércoles",
            notificarFeriados: "Notificar feriados",
            noviembre: "noviembre",
            octubre: "octubre",
            ocurrioErrorRecInfo: "Ocurrió un error mientras se recuperaba la información.",
            sabado: "sabado",
            septiembre: "septiembre",
            validarCaracteresComentario: "El comentario debe tener al menos 5 caracteres.",
            viernes: "viernes",
            vistaPrevia: "Vista previa",
            vistaPreviaNoDisponible: "Vista previa no disponible",
            seleccion: "Selección",
            seleccionados: "Seleccionados",
            todosItemsSeleccionados: "Todos los items seleccionados",
            seleccionado: "Seleccionado",
            sinResultados: "Sin resultados",
            aLas: "A las",
            timeAgoDe: " de",
            ahora: "Ahora",
            seg: "seg",
            haceUnMin: "hace un min",
            minutos: "minutos",
            hoy: "Hoy",
            ayer: "Ayer",
            nuevoElemento: "Nuevo elemento",
        },
        materialTable: {
            header: {
                actions: 'Acciones'
            },
            pagination: {
                labelRowsSelect: 'filas',
                firstTooltip: 'Primera página',
                lastTooltip: 'Última página',
                previousTooltip: 'Página anterior',
                nextTooltip: 'Página siguiente',
                labelDisplayedRows: '{from}-{to} de {count}',
            },
            toolbar: {
                searchPlaceholder: 'Buscar...',
                searchTooltip: 'Buscar',
                exportTitle: 'Exportar',
                exportAriaLabel: 'Exportar',
                exportCSVName: "Exportar como CSV",
                exportPDFName: "Exportar como PDF",
                nRowsSelected: '{0} fila(s) seleccionada(s)',
            },
            body: {
                emptyDataSourceMessage: 'No hay registros que mostrar',
                editRow: {
                    deleteText: '¿Estás seguro de eliminar esta fila?',
                    cancelTooltip: 'Cancelar',
                    saveTooltip: 'Aceptar',
                },
                addTooltip: 'Añadir',
                deleteTooltip: 'Eliminar',
                editTooltip: 'Editar',
            }
        },
        gantt: {
            tarea: "Tarea",
            fechaInicio: "Fecha inicio",
            fechaFin: "Fecha término",
            enero: "enero",
            febrero: "febrero",
            marzo: "marzo",
            abril: "abril",
            mayo: "mayo",
            junio: "junio",
            julio: "julio",
            agosto: "agosto",
            septiembre: "septiembre",
            octubre: "octubre",
            noviembre: "noviembre",
            diciembre: "diciembre",
        },
        arbol: {
            guardar: "Guardar",
        }
    },
    modules: {
        accesos: "Accesos",
        acciones: "Acciones",
        act: "Act.", //Actual
        actualizaDocumento: "Actualiza documento",
        actAfectaActivo: "¿Actividad afecta a un activo de información?",
        actAfectaRiesgo: "¿Actividad afecta a un riesgo?",
        actAtiempo: "Actividades a tiempo",
        actAtrasadas: "Actividades atrasadas",
        actAtrasadasPorVisar: "Actividades atrasadas por visar",
        actAunNoHanSidoCerradas: "Actividades que aún no han sido cerradas",
        actEnCurso: "Actividades en curso",
        actEntregaFormaAtrasada: "Actividades entregadas de forma atrasada",
        actEsperaAprobacion: "Actividades a la espera de aprobación",
        actEsperaSerVisadas: "Actividades en espera ser visadas",
        actHabCuandoActNivSupSeaCompletada: "La actividad se habilitará cuando una actividad de nivel superior sea completada",
        actQueSeEncuentranAtrasadas: "Actividades que se encuentran atrasadas",
        actSiendoCursadas: "Actividades siendo cursadas",
        actTotEjecucionAtrasada: "Actividades totales en estado de ejecución atrasadas",
        actTotEnEstadoEjecAtrasasas: "Actividades totales en estado de ejecución atrasadas",
        actTotEnProcVisacionAtrasada: "Actividades totales en proceso de visación atrasadas",
        actTotEsperaAprob: "Actividades totales a la espera de aprobación",
        actTotProcVisacionAtrasadas: "Actividades totales en proceso de visación atrasadas",
        actTotRechazadas: "Actividades totales rechazadas",
        actTotSiendoCursadas: "Actividades totales siendo cursadas por ejecutores",
        actVencidas: "Actividades vencidas",
        actFinalizadas: "Actividades finalizadas",
        actVisadasAtiempo: "Actividades visadas a tiempo",
        actVisadasConRetraso: "Actividades visadas con retraso",
        activadesAsociadas: "Actividades asociadas",
        actividad: "Actividad",
        actividadCancelada: "Actividad cancelada",
        actividadCompletada: "Actividad Completada",
        actividadSinTerminar: "Actividad sin terminar",
        actividades: "Actividades",
        actividadesEnCurso: "Actividades en curso",
        activo: "Activo",
        activoInfAsociado: "Activo de información asociado",
        activoInformacion: "Activos de información",
        activosDeInformacion: "Activos de información",
        adjuntos: "Adjuntos",
        adjuntosRespuesta: "Adjuntos respuesta",
        adminAct: "Administrar actividades",
        adminCtrl: "Administrar controles",
        adminRiesgo: "Administrar riesgos",
        agregar: "Agregar",
        agruparPorEmpresa: "Agrupar por empresa",
        ajustesUsuario: "Ajustes de usuario",
        ant: "Ant.",
        anterior: "Anterior",
        anual: "Anual",
        aporteConfidencialidad: "Aporte de confidencialidad",
        aporteDisponibilidad: "Aporte de disponibilidad",
        aporteIntegridad: "Aporte de integridad",
        aprobarResidual: "Aprobar residual",
        archivo: "Archivo",
        archivos: "Archivos",
        archivoExcel: "Archivo Excel",
        area: "Área",
        areaDoc: "Área de documento",
        areaDocumentos: "Área documentos",
        areaResponsable: "Área responsable",
        areas: "Áreas",
        areasAuditoria: "Áreas auditoría",
        asignacionActividad: "Asignación de actividad",
        asignacionActividadPorRep: "Asignación de actividad por repetición",
        asignacionLectorDocumento: "Asignación lector de documento",
        atrasada: "Atrasada",
        atrasadas: "Atrasadas",
        atrasadasEjecutores: "Atrasadas ejecutores",
        atrasadasPorAprobar: "Atrasadas por aprobar",
        atrasadasPorEjecutar: "Atrasadas por ejecutar",
        atrasadasPorVisar: "Atrasadas por visar",
        atrasadasVisadores: "Atrasadas visadores",
        atrasos: "Atrasos",
        asignar: "Asignar",
        asignacion: "Asignación",
        asignacionMasiva: "Asignación masiva",
        asignacionMasivaOficios: "Asignación masiva de oficios",
        automatizacion: "Automatización",
        automatizacionControl: "Automatización de control",
        auditoriasTotales: "Auditorías totales",
        auditoriasFinalizadas: "Auditorías finalizadas",
        auditoriasPorEstado: "Auditorías por estado",
        autor: "Autor",
        avisoCierre: "Aviso cierre",
        avisoCierreActividad: "Aviso cierre de actividad",
        avisoDiarioActividad: "Aviso diario de actividades",
        avisoPrevio: "Aviso previo",
        avisoVisacionActividad: "Aviso visación de actividad",
        azureBlob: "Azure blob",
        azureFileShare: "Azure file share",
        googleDrive: "Google Drive",
        baseDeDatos: "Base de datos",
        bibliotecaDocumentos: "Biblioteca de documentos",
        bibliotecaEvidencias: "Biblioteca de evidencias",
        bibliotecaAuditorias: "Biblioteca de auditorías",
        bibliotecaAssessments: "Biblioteca de assessments",
        bibliotecaContratos: "Biblioteca de contratos",
        borrarExitoso: "Operación realizada con éxito. Elemento eliminado",
        buenasNoches: "¡Buenas noches",
        buenasTardes: "¡Buenas tardes",
        buenosDias: "¡Buenos días",
        cada: "Cada",
        calcularVenc: "Calcular vencimiento",
        calendario: "Calendario",
        canalRecepcion: "Canal recepción",
        canalesEnvio: "Canales de envío",
        canalesRecepcion: "Canales de recepción",
        cancelarActividad: "Cancelar actividad",
        cancelarControl: "Cancelar control",
        cargaMasiva: "Carga masiva",
        cargaMasivaOficios: "Carga masiva de oficios",
        cargadoPreviamente: "Cargado previamente:",
        cargos: "Cargos",
        cargar: "Cargar",
        cargaExitosa: "Carga realizada con éxito",
        causa: "Causa",
        cerrar: "Cerrar",
        cerrarActividades: "Cerrar actividades",
        cerrarExitosoActividad: "El sistema cerró exitosamente la actividad",
        ciclo: "Ciclo",
        ciclosProcesos: "Ciclos de procesos",
        cierreDeActividad: "Cierre de actividad",
        cierreMasivo: "Cierre masivo",
        cierreMasivoExitosoActividad: "Cierre masivo realizado",
        cita: "Cita",
        citas: "Citas",
        clasificacion: "Clasificación",
        clasificacionDocumentos: "Clasificación de documentos",
        clasificaciones: "Clasificaciones",
        codAct: "Código de actividad",
        codActPlaceholder: "Ingrese un código",
        codigo: "Código",
        comentario: "Comentario",
        comentarioCierre: "Comentario de cierre",
        comentarioConsecuencia: "Comentario consecuencia",
        comentarios: "Comentarios",
        comentariosVisador: "Comentarios visador",
        compProc: "Comp./Proc.",
        completar: "Completar",
        comprobarConexion: "Comprobar conexión",
        compromiso: "Compromiso",
        compromisoOproceso: "compromiso o proceso",
        compromisos: "Compromisos",
        compromisosVsProrrogasPorGerencia: "Compromisos vs Prórrogas por gerencia",
        conectarConSharepoint: "Conectar con SharePoint",
        conexionExitosa: "Conexión exitosa",
        conexionFallida: "Conexión fallida",
        confidencialidad: "Confidencialidad",
        configBibliotecas: "Config. de bibliotecas",
        configCorreos: "Config. de correos",
        configEtiquetas: "Config. de etiquetas",
        configGenerales: "Config. generales",
        configHorariosCorreos: "Config. de horarios de correos",
        configMapaCalor: "Config. de mapa de calor",
        configNotificaciones: "Config. de notificaciones",
        configRiesgo: "Configuración de riesgo",
        configRol: "Configuración de rol",
        configVisaciones: "Config. de visaciones",
        configVisacionesOficios: "Config. de visaciones oficios",
        configuraciones: "Configuraciones",
        confirmePassword: "Confirme contraseña",
        consecuencia: "Consecuencia",
        consecuencias: "Consecuencias",
        contar: "Contar",
        controlActividades: "Control de actividades",
        controlAreaEmpresa: "Control de áreas de empresas",
        controlAreas: "Control de áreas",
        controlBibliotecas: "Control de bibliotecas",
        controlCanalEnvio: "Control de Canales de envío",
        controlCanalRecepcion: "Control de Canales de recepcion",
        controlCargos: "Control de Cargos",
        controlDelitos: "Control de Delitos",
        controlMaterias: "Control de Materias",
        controlCausas: "Control de causas",
        controlClasificacionesDocumentos: "Control de Clasificaciones de documento",
        controlConsecuencias: "Control de consecuencias",
        controlEmpresas: "Control de Empresas",
        controlEstadoDoc: "Control estados de documento",
        controlEstadoEvRiesgo: "Control de estados de eventos",
        controlCriticidadEvRiesgo: "Control de criticidades de eventos",
        controlTiposEventosRiesgos: "Control de tipos de eventos de riesgo",
        listaTiposEventosRiesgos: "Lista de tipos de eventos de riesgo",
        nuevoTipoEventoRiesgo: "Nuevo tipo de evento de riesgo",
        tiposEventosRiesgos: "Tipos de evento de riesgo",
        tipoEventoRiesgo: "Tipo de evento de riesgo",
        valorMayorCero: "El valor debe ser mayor a 0",
        colorFormatoInvalido: "El color debe estar en formato #RRGGBB",
        controlEstadoPlanAccion: "Control de estados plan de acción",
        controlEstadoOficio: "Control estados de oficio",
        controlFeriados: "Control de Feriados",
        controlFormatoActivos: "Control formatos de activos",
        controlGeneral: "Control general",
        controlGerencias: "Control de Gerencias",
        controlIdTipoCausa: "Control de Identificadores de tipo de causa",
        controlNotificaciones: "Control de notificaciones",
        controlOficinas: "Control de Oficinas",
        controlOrganismosEmisores: "Control de Organismos emisores",
        controlPerfilesAvisos: "Control de perfiles de avisos",
        controlProcesoNivel0: "Control de proceso de ciclos",
        controlProcesoNivel1: "Control de proceso de nivel 1",
        controlProcesoNivel2: "Control de proceso de nivel 2",
        controlProcesoNivel3: "Control de proceso de nivel 3",
        controlProcesoNivel4: "Control de proceso de nivel 4",
        controlRegiones: "Control de regiones",
        controlRelaciones: "Control de Relaciones",
        controlRoles: "Control de roles",
        controlTipoActivos: "Control tipos de activos",
        controlTipoAtrasos: "Control tipos de atrasos",
        controlTipoRiesgos: "Control de Tipos de riesgos",
        controlTiposDocumento: "Control de Tipos de documento",
        controlTiposRequerimiento: "Control de Tipos de requerimiento",
        controlTiposOficio: "Control de Tipos de oficio",
        controlUsuarios: "Control de usuarios",
        controlUbicacionActivos: "Control ubicación de activos",
        controlPlantillas: "Control de plantillas",
        controlGrupoActivos: "Control grupos de activos",
        correoYevidencia: "Correo y evidencia",
        creacion: "Creación",
        crearExitoso: "Operación realizada con éxito. Información guardada",
        criticidad: "Criticidad",
        criticidadActual: "Criticidad actual",
        criticidadInicial: "Criticidad inicial",
        criteriosMitigacion: "Criterios de mitigación",
        cuentaAsociada: "Cuenta asociada",
        dashboard: "Dashboard",
        de: "de",
        deCada: "de cada",
        debeSeleccionarCompProcCrearAct: "Debe seleccionar un compromiso o proceso para crear una actividad",
        debeSeleccionarCompProcCrearRiesgo: "Debe seleccionar un compromiso o proceso para crear un riesgo",
        dependeDe: "Depende de",
        dependencia: "Dependencia",
        desactivado: "Desactivado",
        desactivarEnvioCorreos: "Desactivar envío de correos",
        desaprobarResidual: "Desaprobar residual",
        descargarArchivo: "Descargar archivo",
        descargarError: "Error al generar archivo",
        descargarExitoso: "Archivo generado con éxito",
        descargarMapa: "Descargar mapa",
        descargar: "Descargar",
        descargarTodo: "Descargar todo",
        descripcion: "Descripción",
        descripcionAct: "Descripción de actividad",
        descripcionCont: "Descripción del control",
        descripcionPlanAccion: "Descripción del plan de acción",
        descripcionActPlaceholder: "Ingrese una descripción para la actividad",
        descripcionContPlaceholder: "Ingrese una descripción para el control",
        descripcionPlanAccionPlaceholder: "Ingrese una descripción para el plan de acción",
        descripcionUobjetivo: "Descripción u objetivo",
        desdeFechaVenc: "Desde (Fecha vencimiento)",
        detalle: "Detalle",
        detalleActividad: "Detalle de actividad",
        detalleDeDoc: "Detalle de documento",
        detalleFormula: "Detalle de formula",
        detalleIndicador: "Detalle de indicador",
        detalleProceso: "Detalle de proceso",
        detalleRepeticion: "Detalle repetición",
        detalles: "Detalles",
        dia: "Día",
        diario: "Diario",
        dias: "días",
        diasAntesFechaVencHabAct: "Días antes de la fecha de vencimiento se habilitará la actividad",
        diasAtraso: "Días Atraso",
        diasAvisoPrevio: "Días aviso previo",
        diasCierre: "Días de cierre",
        diasCorridos: "Días corridos",
        diasHabiles: "Días hábiles",
        disponibilidad: "Disponibilidad",
        docAsociado: "Documento asociado",
        docPadre: "Documento padre",
        documento: "Documento",
        documentos: "Documentos",
        duenoProc: "Dueño proc.",
        duenoProceso: "Dueño de proceso",
        enviar: "Enviar",
        editar: "Editar",
        editarActividad: "Editar Actividad",
        editarActivo: "Editar activo",
        editarCompromiso: "Editar compromiso",
        editarDoc: "Editar documento",
        editarExitoso: "Operación realizada con éxito. Información actualizada",
        editarIndicador: "Editar indicador",
        editarProceso: "Editar proceso",
        editarRelacion: "Editar relación",
        editarRiesgo: "Editar riesgo",
        efectividad: "Efectividad",
        efectividadControl: "Efectividad control",
        ejecutar: "Ejecutar",
        ejecutor: "Ejecutor",
        ejecutorActual: "Ejecutor actual",
        eliminar: "Eliminar",
        el: "El",
        elDia: "El día",
        elUltimoDiaDe: "El último día de",
        elUltimoDiaDeCada: "El último día de cada",
        elementosAimportar: "Elementos a importar",
        email: "Email",
        empresa: "Empresa",
        empresaYusuarios: "Empresa y usuarios",
        empresas: "Empresas",
        en: "En",
        enCurso: "En curso",
        enCursoAtrasadas: "En curso atrasadas",
        enEjecucion: "En ejecución",
        enEspera: "En espera",
        enviarCorreoCita: "Enviar correo de cita",
        enviarResumenAlAdmin: "Envía resumen a administrador",
        enviarResumenAlAdminDatos: "Envía resumen al administrador de datos",
        errorFaltaArchivoExcel: "Debe ingresar el archivo excel para continuar.",
        errorEmpresa: "Se debe seleccionar una empresa para continuar",
        errorConectarSharepoint: "Error al intentar conectar con SharePoint",
        errorDesconocido: "Error desconocido",
        errorPeso: "La evidencia a adjuntar debe ser de un peso menor o igual a: ",
        errorIngresarExcel: "Debe ingresar el archivo excel para continuar.",
        errores: "Errores: ",
        erroresAuto: "Errores",
        esBinario: "Es binario",
        esInformativa: "¿Es una actividad informativa?",
        esperaVisacion: "Espera de visación",
        estableceDiasConsideradoVenc: "Establece los días que son considerados para el vencimiento",
        establecePtjeMitigacionConsecuencia: "Variable que establece el porcentaje de mitigación de probabilidad del riesgo con esta actividad de control",
        establecePtjeMitigacionProbabilidad: "Variable que establece el porcentaje de mitigación de impacto del riesgo con esta actividad de control",
        estableceSiActividadEjecutaEnHabil: "Establece si la actividad se ejecutará en días habiles o no",
        estableceSiDebeMostrarCuadroAlSeleccCanal: "Establece si se debe desplegar un cuadro de texto al seleccionar este canal",
        estableceSiFeriadoRepite: "Establece si el feriado se repetirá cada año o es un feriado puntual",
        estadisticas: "Estadísticas",
        estado: "Estado",
        compromisosPorEstado: "Compromisos por estado",
        compromisosPorCriticidad: "Compromisos por criticidad",
        porGerencia: "Por gerencia",
        estadoEventosRiesgos: "Estado de evento de riesgo",
        estadosEventosRiesgos: "Estados de evento de riesgo",
        criticidadesEventosRiesgos: "Criticidades de evento de riesgo",
        estadosPlanAccion: "Estados de plan de acción",
        estadoAprobacion: "Estado aprob.",
        estadoDoc: "Estado documento",
        estadoEjecucion: "Estado ejecución",
        estadoEntrega: "Estado de entrega",
        estadoRevision: "Estado revisión",
        estadoVisacion: "Estado visación",
        estadosDocumento: "Estados documento",
        etiqueta: "Etiqueta",
        eventual: "Eventual",
        evidencia: "Evidencia",
        evidenciaBorrada: "Evidencia borrada",
        exigeDetalle: "Exige detalle",
        exigeEvidenciaCerrarActividad: "Se exige evidencia al cerrar actividades",
        exigeFirmaAprobarSolicitudDoc: "Se exige firma para aprobar solicitudes de documentos",
        exigeEvidenicaFormaPredeterminada: "Se exige evidencia de forma predeterminada",
        exportarCsv: "Exportar CSV",
        exportarExcel: "Exportar Excel",
        exportarPdf: "Exportar PDF",
        fecha: "Fecha",
        fechaAl: "Al",
        fechaCarga: "Fecha de carga",
        fechaCierre: "Fecha cierre",
        fechaDesde: "Desde",
        fechaHasta: "Hasta",
        fechaEjecucion: "Fecha ejecución",
        fechaIngreso: "Fecha ingreso",
        fechaIngresoAlSistema: "Fecha ingreso al sistema",
        fechaPublicacion: "Fecha publicación",
        fechaRecepcionEmpresa: "Fecha recepción empresa",
        fechaRevision: "Fecha revisión",
        fechaPlazoRespuesta: "Fecha plazo de respuesta",
        plazoRespuestaInterno: "Plazo de respuesta interno",
        fechaPlazoInterno: "Plazo interno",
        fechaEmision: "Fecha emisión oficio",
        fechaVenc: "Fecha de vencimiento",
        fechaFirma: "Fecha de firma",
        fechaVisacion: "Fecha visación",
        feriados: "Feriados",
        filtrar: "Filtrar",
        filtrarPor: "Filtrar por",
        filtrarPorFecha: "Filtrar por fechas",
        soloConEventoRiesgo: "Solo con eventos de riesgo",
        soloConPlanAccion: "Solo con planes de acción",
        filtros: "Filtros",
        footerCorreoEjecutor: "Footer correo ejecutor",
        footerCorreoVisador: "Footer correo visador",
        formula: "Formula",
        frecControl: "Frecuencia de control",
        frecuencia: "Frecuencia",
        generaExcelConsolRiesgosProcCtr: "Genera un Excel consolidado de riesgos, procesos y controles.",
        general: "General",
        generales: "Generales",
        gerencia: "Gerencia",
        gerencias: "Gerencias",
        gerente: "Gerente",
        gestorActControl: "Gestor de controles",
        gestorActividades: "Gestor de actividades",
        gestorPlanesAccion: "Gestor planes de acción",
        gestorActivosInformacion: "Gestor de activos de información",
        gestorCompromisosYprocesos: "Gestor de compromisos y procesos",
        gestorCompromisos: "Gestor de compromisos",
        gestorDocumentos: "Gestor de documentos",
        gestorIndicadores: "Gestor de indicadores",
        gestorRiesgos: "Gestor de riesgos",
        gestorMisRiesgos: "Gestor mis riesgos",
        gestorEventoRiesgos: "Gestor de eventos de riesgo",
        gestorProyectos: "Gestor de proyectos",
        gestorProcesos: "Gestor de procesos",
        gestorCodigosOficios: "Gestor de códigos oficios",
        guardar: "Guardar",
        guardarActividad: "Guardar actividad",
        guardarActivo: "Guardar activo",
        guardarCambios: "Guardar cambios",
        guardarDoc: "Guardar documento",
        guardarIndicador: "Guardar indicador",
        guardarRiesgo: "Guardar riesgo",
        hastaFechaVenc: "Hasta (Fecha vencimiento)",
        historial: "Historial",
        historialRepeticiones: "Historial de repeticiones",
        hora: "Hora",
        hoy: "Hoy",
        identificacion: "Identificación",
        identificadorCausa: "Identificador causa",
        identificadoresCausas: "Identificadores de causas",
        idioma: "Idioma",
        igualA: "Igual a",
        importacion: "Importación",
        importador: "Importador",
        importar: "Importar",
        importarDocumentosYcompromisos: "Importar documentos y compromisos",
        importacionMasiva: "Importación masiva",
        importacionMasivaProcesoRiesgos: "Importación masiva de procesos y riesgos",
        importacionMasivaMetodologiaRiesgos: "Importación de metodología de riesgos",
        modoImportacionMetodologia: "Modo de importación",
        nuevaMetodologia: "Crear nueva metodología",
        reemplazarMetodologia: "Reemplazar metodología existente",
        nombreMetodologia: "Nombre de metodología",
        errorNombreMetodologia: "Debe ingresar un nombre de metodología",
        seleccioneMetodologia: "Debe seleccionar una metodología",
        importacionMasivaProcesos: "Importación masiva de procesos",
        importacionMasivaRiesgos: "Importación masiva de riesgos",
        importacionMasivaReporte: "Importación masiva de reporte",
        importacionMasivaIndicadores: "Importación masiva de indicadores",
        importacionMasivaLectoresIndicadores: "Importación masiva de lectores indicadores",
        importacionMasivaHallazgosDoc: "Importación masiva de hallazgos",
        importacionMasivaEventosRiesgo: "Importación masiva eventos de riesgo",
        importacionMasivaPlanesAccion: "Importación masiva planes de acción",
        importacionMasivaOrganigrama: "Importación masiva de organigrama",
        importacionMasivaCumplimiento: "Importación masiva de cumplimiento",
        importacionMasivaRelGerDocUsuario: "Importación masiva rel gerencia/área/usuario",
        importacionMasivaRelBandejaUsuario: "Importación masiva rel bandeja/usuario",
        actualizacionMasiva: "Actualización masiva",
        importarExitoso: "El sistema importó exitosamente los elementos",
        incluirDetalle: "Incluir detalle",
        incluirEncabezado: "Incluir encabezado",
        incluyeFirma: "Incluye firma",
        indicador: "Indicador",
        indicadoresPorRevisar: "Indicadores por revisar",
        indiceCons: "Índice Cons.",
        indiceConsecuencia: "Índice impacto",
        indiceProb: "Índice Prob.",
        indiceProbabilidad: "Índice probabilidad",
        informacion: "Información",
        informacionGral: "Información general",
        informativa: "Informativa",
        informativas: "Informativas",
        informativo: "Informativo",
        ingreseCadenaConexion: "Ingrese cadena de conexión",
        ingreseCarpeta: "Ingrese carpeta",
        ingreseContenedor: "Ingrese contenedor",
        comentarioRieIndPlaceholder: "Ingrese un comentario obligatorio para el indicador",
        ingreseComentarioConsecuencia: "Ingrese un comentario para la consecuencia...",
        ingreseComentarioParaControl: "Ingrese un comentario para el control...",
        ingreseCorreo: "Ingrese correo",
        ingreseDescripDoc: "Ingrese una descripción para el documento",
        ingreseDescripIdentificador: "Ingrese una descripción para el identificador",
        ingreseDescripTipoActivo: "Ingrese una descripción para el tipo de activo",
        ingreseDescripTipoDoc: "Ingrese una descripción para el tipo de documento",
        ingreseDescripTipoReq: "Ingrese una descripción para el tipo de requerimiento",
        ingreseDescripTipoRiesgo: "Ingrese una descripción para el tipo de riesgo",
        ingreseDescripUobjetivoCompromiso: "Ingrese una descripción u objetivo para el compromiso",
        ingreseObjetivoProceso: "Ingrese un objetivo para el proceso",
        ingreseDescripcion: "Ingrese una descripción",
        ingreseDescripcionActivo: "Ingrese una descripción para el activo",
        ingreseDetalleIndicador: "Ingrese detalle de indicador",
        ingreseDiasVisacion: "Ingrese días de visación",
        ingreseEmpresa: "Ingrese empresa",
        ingreseEtiquetaGerencia: "Ingrese etiqueta gerencia",
        ingreseEtiquetaGerente: "Ingrese etiqueta gerente",
        ingreseEtiquetaResponsable: "Ingrese etiqueta responsable",
        ingreseHostCorreo: "Ingrese host de correo",
        ingreseLaFormula: "Ingrese la formula, Ej. a+b",
        ingreseLaMedida: "Ingrese la medida, Ej. % o $",
        ingreseLaTolerancia: "Ingrese la tolerancia",
        ingreseNombre: "Ingrese nombre",
        ingreseNombreDespliegue: "Ingrese nombre despliegue",
        ingreseObjetivoIndicador: "Ingrese objetivo de indicador",
        ingresePassword: "Ingrese contraseña",
        ingresePuerto: "Ingrese puerto",
        ingreseRutaCarpeta: "Ingrese ruta de carpeta",
        ingreseUrlSitio: "Ingrese URL del sitio",
        ingreseValor: "Ingrese valor",
        integridad: "Integridad",
        jueves: "Jueves",
        laEvidenciaEsObligatoria: "¿La evidencia es obligatoria?",
        lector: "Lector",
        lectores: "Lectores",
        listaAreaEmpresas: "Lista de áreas de empresas",
        listaAreas: "Lista de áreas",
        listaCanales: "Lista de canales",
        listaCargos: "Lista de cargos",
        listaDelitos: "Lista de delitos",
        listaMaterias: "Lista de materias",
        listaCiclos: "Lista de ciclos",
        listaClasificaciones: "Lista de clasificaciones",
        listaConsecuencias: "Lista de consecuencias",
        listaEmpresas: "Lista de empresas",
        listaEstadoDoc: "Lista de estados de documento",
        listaEstadoOficio: "Lista de estados de oficio",
        listaEstadoEvRiesgo: "Lista de estados de eventos de riesgo",
        listaCriticidadEvRiesgo: "Lista de criticidades de eventos de riesgo",
        listaEstadoPlanAccion: "Lista de estados de plan de acción",
        listaFeriados: "Lista de feriados",
        listaFormatoActivos: "Lista de formatos de activo",
        listaGerencias: "Lista de gerencias",
        listaIdentificadores: "Lista de Identificadores",
        listaOficinas: "Lista de oficinas",
        listaOrganismosEmisores: "Lista de organismos emisores",
        listaPerfilesEnvioCorreos: "Lista perfiles envío de correos",
        listaProcesos: "Lista de procesos",
        listaRegiones: "Lista de regiones",
        listaRelacionesEmpresaGerenciaAreaUsuario: "Lista de relaciones Empresa/Gerencia/Área/Usuarios",
        listaRiesgos: "Lista de riesgos",
        listaRoles: "Lista de roles",
        listaTipoActivos: "Lista de tipos de activo",
        listaTipoAtrasos: "Lista tipo de atrasos",
        listaTipoRiesgos: "Lista de tipos de riesgos",
        listaSubTipoRiesgos: "Lista de sub-tipos de riesgos",
        listaTiposDocumento: "Lista de tipos de documento",
        listaTiposRequerimientos: "Lista de tipos requerimientos",
        listaTiposOficio: "Lista de tipos de oficio",
        listaUsuarios: "Lista de usuarios",
        listaUbicacionActivos: "Lista de ubicaciones de activo",
        listaValoresRiesgoControles: "Lista de valores riesgo controles",
        listaValoresRiesgoInherente: "Lista de valores riesgo inherente",
        listaPlantillas: "Lista de plantillas",
        listaGrupoActivos: "Lista de grupos de activos",
        lunes: "Lunes",
        mapaDeCalor: "Mapa de calor",
        martes: "Martes",
        matrizRiesgos: "Matriz de riesgos",
        matrizValorizacion: "Matriz de valorización",
        maximo: "Máximo",
        maximoCargaArchivo: "Tamaño máximo de carga",
        medida: "Medida",
        mensual: "Mensual",
        mes: "Mes",
        meses: "meses",
        miercoles: "Miércoles",
        minimo: "Mínimo",
        misAct: "Mis actividades",
        misActAtrasadasPorAprobar: "Mis act. atrasadas por aprobar",
        misActAtrasadasPorEjecutar: "Mis act. atrasadas por ejecutar",
        misActEnCurso: "Mis act. en curso",
        misActPorAprobar: "Mis act. por aprobar",
        misActividades: "Mis Actividades",
        misIndicadores: "Mis indicadores",
        mitigacionCriticidad: "Mitigación criticidad",
        modoPosicionamientoRiesgo: "Modo de posicionamiento de riesgo",
        mostrar: "Mostrar",
        motivo: "Motivo",
        motivoAtraso: "Motivo de atraso",
        motivosAtrasos: "Motivos de atrasos",
        motivoSolicitud: "Motivo solicitud",
        nadaPorRevisar: "Nada por revisar",
        nadaPorVisar: "Nada por visar",
        nivel: "Nivel",
        nivel1: "Nivel 1",
        nivel2: "Nivel 2",
        nivel3: "Nivel 3",
        nivel4: "Nivel 4",
        nivelTolerancia: "Nivel de tolerancia",
        niveles: "Niveles",
        nivelesDeProcesos: "Niveles de procesos",
        no: "No",
        noEncontrado: "No encontrado.",
        noEspecificado: "No especificado",
        noVigente: "No vigente",
        noVistoPorNadie: "Aún no ha sido visto por nadie",
        nombre: "Nombre",
        nombreArea: "Nombre de área",
        nombreCanal: "Nombre canal",
        nombreCanalDetalle: "Nombre canal detalle",
        nombreCanalEnvio: "Nombre canal envío",
        nombreCanalRecepcion: "Nombre canal recepción",
        nombreCargo: "Nombre cargo",
        nombreCiclo: "Nombre de ciclo",
        nombreCompleto: "Nombre completo",
        nombreCompromiso: "Nombre compromiso",
        nombreDoc: "Nombre documento",
        nombreEmpresa: "Nombre empresa",
        nombreFeriado: "Nombre feriado",
        nombreGerencia: "Nombre gerencia",
        nombreGralProceso: "Nombre general del proceso",
        nombreIdentificador: "Nombre identificador",
        nombreIndicador: "Nombre de indicador",
        nombreOficina: "Nombre oficina",
        nombreOrganismo: "Nombre organismo",
        nombrePerfil: "Nombre de perfil",
        nombreProceso: "Nombre proceso",
        nombreRegion: "Nombre región",
        nombreRol: "Nombre de rol",
        nombreTipoDoc: "Nombre tipo doc.",
        nombreTipoReq: "Nombre tipo req.",
        nombreTipoRiesgo: "Nombre de tipo riesgo",
        nombreSubTipoRiesgo: "Nombre de sub-tipo riesgo",
        nombreUsuario: "Nombre de usuario",
        nombreYapellido: "Ingrese nombre y apellidos",
        nro: "N°",
        nroCausa: "N° causa",
        nroRep: "N° Rep.",
        nuevaActividad: "Nueva Actividad",
        nuevaArea: "Nueva área",
        nuevaAreaEmpresa: "Nueva área empresa",
        nuevaClasificacion: "Nueva clasificación",
        nuevaConsecuencia: "Nueva consecuencia",
        nuevaEmpresa: "Nueva empresa",
        nuevaGerencia: "Nueva gerencia",
        nuevaOficina: "Nueva oficina",
        nuevaFechaPlazo: "Nueva fecha de plazo",
        nuevaRegion: "Nueva región",
        nuevaRelacion: "Nueva relación",
        nuevaCriticidad: "Nueva criticidad",
        nuevoActivo: "Nuevo activo",
        nuevoCanal: "Nuevo canal",
        nuevoCargo: "Nuevo cargo",
        nuevoDelito: "Nuevo delito",
        nuevaMateria: "Nueva materia",
        nuevoCiclo: "Nuevo ciclo",
        nuevoCompromiso: "Nuevo compromiso",
        nuevoDoc: "Nuevo documento",
        nuevoEstadoDoc: "Nuevo estado de documento",
        nuevoEstadoOficio: "Nuevo estado de oficio",
        nuevoEstadoEvRiesgo: "Nuevo estado de evento",
        nuevaCriticidadEvRiesgo: "Nueva criticidad de evento",
        nuevoEstadoPlanAccion: "Nuevo estado de plan de acción",
        nuevoFeriado: "Nuevo Feriado",
        nuevoFormatoActivo: "Nuevo formato de activo",
        nuevoIdentificador: "Nuevo identificador",
        nuevoIndicador: "Nuevo indicador",
        nuevoOrganismoEmisor: "Nuevo organismo emisor",
        nuevoPerfil: "Nuevo perfil",
        nuevoProceso: "Nuevo proceso",
        nuevoRiesgo: "Nuevo riesgo",
        nuevoRol: "Nuevo rol",
        nuevoTipoActivo: "Nuevo tipo de activo",
        nuevoUbicacionActivo: "Nueva ubicación de activo",
        nuevoTipoAtraso: "Nuevo tipo de atraso",
        nuevoTipoDocumento: "Nuevo tipo de documento",
        nuevoTipoReq: "Nuevo tipo req.",
        nuevoTipoRiesgo: "Nuevo tipo de riesgo",
        nuevoSubTipoRiesgo: "Nuevo sub-tipo de riesgo",
        nuevoTipoOficio: "Nuevo tipo de oficio",
        nuevoUsuario: "Nuevo usuario",
        nuevoGrupoActivo: "Nuevo grupo de activo",
        objetivo: "Objetivo",
        objetivos: "Objetivos",
        periodo: "Periodo",
        nuevoPeriodo: "Nuevo período",
        repObjetivosEstrategicos: "Reporte de objetivos estratégicos",
        objetivosEstrategicos: "Objetivos estratégicos",
        resumenConsolidado: "Resumen consolidado",
        cumplimientoPorPerspectiva: "Cumplimiento por perspectiva",
        cumplimientoGlobal: "Cumplimiento global",
        cumplimientoPromedio: "Cumplimiento promedio",
        objetivosPorPerspectiva: "Objetivos por perspectiva",
        distribucionCumplimiento: "Distribución de cumplimiento",
        gestorObjetivosEstrategicos: "Gestor de objetivos estratégicos",
        gestorIndicadoresEstrategicos: "Gestor de indicadores estratégicos",
        indicadoresEstrategicos: "Indicadores estratégicos",
        objetivoEstrategico: "Objetivo estratégico",
        nuevoObjetivoEstrategico: "Nuevo objetivo estratégico",
        editarObjetivoEstrategico: "Editar objetivo estratégico",
        seguroDeseaEliminarObjetivo: "¿Estás seguro de que deseas eliminar el objetivo",
        iniciativa: "Iniciativa",
        iniciativas: "Iniciativas",
        nuevaIniciativa: "Nueva iniciativa",
        editarIniciativa: "Editar iniciativa",
        sinIniciativas: "Sin iniciativas registradas.",
        deseaReportarResultadoPeriodo: "¿Desea reportar resultado para el periodo?",
        perspectiva: "Perspectiva",
        perspectivas: "Perspectivas",
        gestorPerspectivas: "Gestor de perspectivas",
        nuevaPerspectiva: "Nueva perspectiva",
        editarPerspectiva: "Editar perspectiva",
        seguroDeseaEliminarPerspectiva: "¿Estás seguro de que deseas eliminar la perspectiva",
        controlDirPerspectivas: "Control de perspectivas BSC",
        listaDirPerspectivas: "Lista de perspectivas BSC",
        objetivoIndicador: "Objetivo del indicador",
        oficina: "Oficina",
        oficinas: "Oficinas",
        opciones: "Opciones",
        oportunidad: "Oportunidad",
        oportunidadControl: "Oportunidad de control",
        orden: "Orden",
        orgEmisor: "Org. emisor",
        organismoEmisor: "Organismo emisor",
        organismosEmisores: "Organismos emisores",
        paso: "Paso",
        pasosFlujo: "Pasos del flujo",
        pendiente: "Pendiente",
        pendientesAprob: "Pendientes aprobación",
        pendientesEjecucion: "Pendientes ejecución",
        perfil: "Perfil",
        perfilAviso: "Perfil de aviso",
        perfiles: "Perfiles",
        perfilesEnvioCorreos: "Perfiles envío de correos",
        periodicidad: "Periodicidad",
        periodicidadRiesgo: "Periodicidad del riesgo",
        validarPeriodicidadRiesgo: " Debe seleccionar una periodicidad del riesgo.",
        periodico: "Periódico",
        permanente: "Permanente",
        permisos: "Permisos",
        plazoVisadorTexto: "Plazo visador texto",
        planAuditorias: "Planes de auditorías",
        porAprobar: "Por aprobar",
        porRevisar: "Por revisar",
        porVencer: "Por vencer",
        porVisar: "Por visar",
        porcentajeMitigacionConsecuencia: "% Mitigación impacto",
        porcentajeMitigacionProbabilidad: "% Mitigación probabilidad",
        prefijoEmail: "Prefijo email",
        primer: "primer",
        primerVenc: "Primer vencimiento",
        probabilidad: "Probabilidad",
        procAsociado: "Proceso asociado",
        proceso: "Proceso",
        procesoNivel1: "Proceso de nivel 1",
        procesoNivel2: "Proceso de nivel 2",
        procesoNivel3: "Proceso de nivel 3",
        procesos: "Procesos",
        procesosNivel1: "Procesos nivel 1",
        procesosNivel2: "Procesos nivel 2",
        procesosNivel3: "Procesos nivel 3",
        procesosNivel4: "Procesos nivel 4",
        proxVenc: "Próx. venc.",
        proxVencimiento: "Próx. vencimiento",
        proxVencimientos: "Próximos vencimientos",
        puntual: "Puntual",
        puntoRetorno: "Punto retorno",
        retorno: "Retorno",
        rangos: "Rangos",
        requierePrerevisor: "Requiere pre-revisor",
        rebajaMasiva: "Rebaja masiva",
        rebajaMasivaOficios: "Rebaja masiva de oficios",
        realizarImportacion: "Realizar importación",
        reasignacionExitosoActividad: "Reasignación exitosa",
        reasignacionExitosaCompromisos: "Compromisos reasignados exitosamente",
        reasignacionExitosaIndicadores: "Indicadores reasignados exitosamente",
        reasignacionExitosaPlanesAccion: "Planes de acción reasignados exitosamente",
        reasignacionMismoUsuario: "No pueden reasignar oficios al mismo usuario",
        reasignacionMismoUsuarioAdtCompromiso: "No se puede reasignar compromisos al mismo usuario",
        reasignacionMasiva: "Reasignación masiva",
        reasignacionMasivaOficios: "Reasignación masiva oficios",
        reasignacionMasivaIndicadores: "Reasignación masiva de indicadores",
        reasignacionMasivaReglasAdt: "Reasignación masiva reglas de auditoría",
        reasignacionMasivaAdtCompromisos: "Reasignación masiva compromisos",
        reasignarA: "Reasignar a",
        reasignarActividades: "Reasignar actividades",
        reasignarPlanesAccion: "Reasignar planes de acción",
        reasignarOficios: "Reasignar oficios",
        recepcion: "Recepción",
        rechazaYcierraAct: "Rechaza y cierra la actividad",
        rechazaYdevuelveActAlEjecutor: "Rechaza y devuelve la actividad al ejecutor",
        rechazadas: "Rechazadas",
        rechazar: "Devolver a ejecutor",
        rechazarYcerrar: "Rechazar y cerrar",
        recurrente: "Recurrente",
        regionOseccion: "Región/Sección",
        regiones: "Regiones",
        registrarResultado: "Registrar resultado",
        relaciones: "Relaciones",
        repRechazadas: "Repeticiones rechazadas",
        remitente: "Remitente",
        rendimiento: "Rendimiento",
        rendimientoHistorico: "Rendimiento histórico",
        rendimientoGral: "Rendimiento general",
        repiteHasta: "Repetir hasta",
        representanteLegal: "Representante legal",
        requerimiento: "Requerimiento",
        requiereVisacion: "¿Requiere visación?",
        responsable: "Responsable",
        responsableIndicador: "Responsable del indicador",
        resultado: "Resultado",
        resumen: "Resumen",
        resumenActividadSemanal: "Resumen de actividades semanal",
        resumenSemanal: "Resumen semanal",
        resumenGeneral: "Resumen general",
        revisar: "Revisar",
        riesgo: "Riesgo",
        riesgoAsociado: "Riesgo asociado",
        riesgoInherente: "Riesgo inherente",
        riesgoResidual: "Riesgo residual",
        riesgoTiempoReal: "Riesgo en tiempo real",
        riesgos: "Riesgos",
        rol: "Rol",
        roles: "Roles",
        rolesUsuario: "Roles de usuario",
        seguroDeseaBorrarEvidencia: "¿Seguro que desea borrar la evidencia seleccionada?",
        seguroDeseaCancelarActividad: "¿Estás seguro de que deseas cancelar la actividad?",
        seguroDeseaCancelarControl: "¿Estás seguro de que deseas cancelar el control?",
        seguroDeseaEliminarCompromiso: "¿Estás seguro de que deseas eliminar el compromiso",
        seguroDeseaEliminarDoc: "¿Estás seguro de que deseas eliminar el documento",
        seguroDeseaEliminarIndicador: "¿Estás seguro de que deseas eliminar el indicador?",
        seguroDeseaEliminarProc: "¿Estás seguro de que deseas eliminar el proceso",
        seguroDeseaEliminarRelacion: "¿Estás seguro de que deseas eliminar la relación?",
        seguroDeseaEliminarRiesgo: "¿Estás seguro de que deseas eliminar el riesgo",
        seguroDeseaEliminarResultado: "¿Estás seguro de que deseas eliminar el resultado?",
        seguroDeseaEliminarEventoRiesgo: "¿Estás seguro de que deseas eliminar el evento de riesgo",
        seguroDeseaGuardarResFueraUmbral: "¿Estás seguro de que deseas guardar un resultado fuera de umbral?",
        seleccioneCsvConDocYcomp: "Seleccione CSV con documentos y compromisos",
        semana: "Semana",
        semanaEl: "semana, el",
        semanal: "Semanal",
        sharepoint: "SharePoint",
        si: "Si",
        sigla: "Sigla",
        siguiente: "Siguiente",
        sinDocAsociado: "Sin documento asociado.",
        sinIndicadorInfo: "Sin información para mostrar",
        sinIndicadores: "Sin indicadores",
        sinRiesgoAsociado: "Sin riesgo asociado.",
        sinRiesgosAsociados: "Sin riesgos asociados",
        sinRol: "Sin rol asignado. Contáctese con el administrador.",
        sinRetorno: "Sin retorno",
        sinTareasPendientes: "Sin tareas pendientes",
        soloDiaHabil: "Solo día hábil",
        tarea: "Tarea",
        tareaCerrada: "Tarea cerrada",
        tareasEnCurso: "Tareas en curso",
        tareasPorVisar: "Tareas por visar",
        textoMostrarUrlTareas: "Texto a mostrar URL de tareas",
        textoMostrarUrlVisador: "Texto a mostrar URL de visador",
        terminaFlujo: "Termina flujo",
        tipo: "Tipo",
        tipoAlmacenamiento: "Tipo de almacenamiento",
        tipoControl: "Tipo de control",
        tipoDoc: "Tipo de documento",
        tipoDocumentos: "Tipo documentos",
        tipoIndicador: "Tipo de indicador",
        tipoRiesgo: "Tipo de riesgo",
        tiposActivos: "Tipos de activos",
        tiposAtrasos: "Tipos de atrasos",
        tiposRequerimientos: "Tipos de requerimientos",
        tiposRiesgos: "Tipos de riesgos",
        todas: "Todas",
        todasEmpresas: "Todas las empresas",
        todo: "Todo",
        todoDiasSemana: "Todos los días de la semana",
        todos: "Todos",
        todosEjecutores: "Todos los ejecutores",
        todosVisadores: "Todos los visadores",
        toleracionAutoAprobRiesgoResidual: "Tolerancia auto-aprob. r. residual",
        tolerancia: "Tolerancia",
        tooltipCalcularFechaVenc: "Calcular vencimiento según frecuencia",
        totAtrasadas: "Total atrasadas",
        ubicacionYarchivos: "Ubicación y archivos",
        ultimo: "último",
        umbral: "Umbral",
        urlExterna: "URL externa",
        usarConfigSistema: "Usar configuración del sistema",
        usarNivelesProcComoNombre: "Usar niveles de proceso como nombre",
        usarSsl: "Usar SSL",
        usuario: "Usuario",
        usuarios: "Usuarios",
        usuarioOpcional: "Usuario (opcional)",
        utilizarLoginProvExterno: "Utilizar inicio de sesión con proveedor externo",
        validacionAreaCrearDoc: "Se debe contar con un área para crear el documento",
        validacionComentarioCierreMasivo: "Debe escribir un comentario de cierre",
        validacionCompromisoCrearRiesgo: "Se debe contar con un compromiso/proceso antes de crear el riesgo",
        validacionDocCrearCompromiso: "Se debe contar con un documento antes de crear el compromiso",
        validacionEmpresa: "Se debe contar con una empresa para continuar",
        validacionGerenciaCrearProc: "Se debe contar con una gerencia antes de crear el proceso",
        validacionNivel1CrearProc: "Se debe contar con un nivel 1 antes de crear el proceso",
        validacionOrgEmisorCrearDoc: "Se debe contar con un organismo emisor para crear el documento",
        validacionTipoCrearDoc: "Se debe contar con un tipo para crear el documento",
        validarConsecuenciaCrearActividad: "Se debe seleccionar una consecuencia",
        validarDescripcionCrearActividad: "La actividad debe tener una descripción",
        validarDetalleCrearIndicador: "El indicador debe tener un detalle",
        validarDiasAvisoPrevioCrearActividad: "Días de aviso previo debe ser mayor o igual a cero",
        validarDiasNegativosCrearActividad: "Días no pueden ser negativos",
        validarDifMinMaxMenor2CrearIndicador: "Diferencia entre valores mínimo y máximo de umbrales 1 y 3 debe ser de al menos 2 unidades",
        validarEmpresaCliente: "Se debe contar con una empresa antes de crear un cliente",
        validarEmpresaGerencia: "Se debe contar con una empresa antes de crear una gerencia",
        validarEmpresaGerenciaCrearActividad: "La actividad debe tener una empresa y gerencia",
        validarEmpresaGerenciaRelacion: "Se debe contar con una empresa>gerencia antes de crear una relación",
        validarEtiquetaReqCrearIndicador: "Las etiquetas son requeridas",
        validarEtiquetasNoIgualesCrearIndicador: "Las etiquetas no deben ser iguales",
        validarExistenciaElementosSeleccionadosImportador: "Uno o más elementos seleccionados ya se encuentran en el sistema",
        validarFormulaCrearIndicador: "El indicador debe tener una formula",
        validarGerenteEjecutorVisadorCrearActividad: "La actividad debe tener un gerente, ejecutor y/o visador",
        validarVisadorPlanAccion: "El plan de acción debe tener un visador",
        validarEjecutorDuenoProcesoActividad: "La actividad debe tener un dueño de proceso y un ejecutor",
        validarLectores: "La actividad debe tener al menos un lector",
        validarMaxUmbral1CrearIndicador: "Valor máximo de umbral 1 debe ser mayor que valor mínimo",
        validarMaxUmbral3MayorAlMinCrearIndicador: "Valor máximo de umbral 3 debe ser mayor que valor mínimo",
        validarMedidaCrearIndicador: "El indicador debe tener una medida",
        validarMesesNegativosCrearActividad: "Meses no pueden ser negativos",
        validarMitigacionConsecuenciaCrearActividad: "% Mitigación consecuencia debe estar entre 0 y 100",
        validarMitigacionProbabilidadCrearActividad: "% Mitigación probabilidad debe estar entre 0 y 100",
        validarMotivoCancelarActividad: "Debe ingresar un motivo",
        validarNombreCrearIndicador: "El indicador debe tener un nombre",
        validarNombreUsuarioUsuario: "Nombre de usuario no puede contener espacios",
        validarObjetivoCrearIndicador: "El indicador debe tener un objetivo",
        validarPasswordUsuario: "La contraseña debe tener al menos 10 caracteres, un carácter especial, una mayúscula y un número",
        validarPasswordsUsuario: "Las contraseñas ingresadas no coinciden",
        validarNombreCompletoUsuario: "El nombre debe tener al menos 4 caracteres",
        validarProcesoNivel1Nivel2: "Se debe contar con un proceso de nivel 1 antes de crear un nivel 2",
        validarProcesoNivel2Nivel3: "Se debe contar con un proceso de nivel 2 antes de crear un nivel 3",
        validarProcesoNivel3Nivel4: "Se debe contar con un proceso de nivel 3 antes de crear un nivel 4",
        validarRiesgoCrearActividad: "Debe actualizar riesgo antes de guardar",
        validarRolPerfil: "Se debe seleccionar al menos un rol",
        validarSeleccActivoCrearActividad: "Se debe seleccionar un activo de información",
        validarSeleccRiesgoCrearActividad: "Se debe seleccionar un riesgo",
        validarToleranciaCrearIndicador: "El indicador debe tener un nivel de tolerancia",
        validarUmbralesRegistrarResultadoIndicador: "Resultado de indicador fuera de los umbrales establecidos",
        validarValoresMinMaxUmbral1y3NoIgualesCrearIndicador: "Valores mínimos y máximos de umbrales 1 y 3 no deben ser iguales",
        validarValoresUmbraleaNoIgualesCrearIndicador: "Valores de umbrales no pueden ser iguales",
        validacionEmpresaCrearProyecto: "Se debe contar con una empresa antes de crear un proyecto",
        validacionPlantillaCrearProyecto: "Se debe contar con una plantilla antes de crear un proyecto",
        validacionProyectoCrearRelacion: "Se debe seleccionar un proyecto para crear la relación",
        valor: "Valor",
        valorLimite: "Valor limite",
        valorResidual: "Valor residual",
        valorRiesgo: "Valor riesgo",
        valores: "Valores",
        valorizacion: "Valorización",
        valorizacionActivo: "Valorización de activo",
        valorizacionControles: "Valorización controles",
        valorizacionRiesgoControles: "Valorización riesgo controles",
        valorizacionRiesgoInherente: "Valorización riesgo inherente",
        valorizarRiesgoInherente: "Valorizar riesgo inherente",
        var: "Var.",
        vencDias: "Venc. en días",
        venceHoy: "Vence hoy",
        vencida: "Vencida",
        vencidas: "Vencidas",
        vencido: "Vencido",
        vencidos: "Vencidos",
        vencimiento: "Vencimiento",
        verComo: "Ver como",
        verMapaCalor: "Ver mapa de calor",
        verRiesgosTiempoReal: "Ver riesgos tiempo real",
        viernes: "Viernes",
        vigente: "Vigente",
        campo: "Campo",
        visaLaActividad: "Visa la actividad",
        visacionDeActividad: "Visación de actividad",
        visacionExitosaActividad: "El sistema visó exitosamente la actividad",
        devueltaExitosoActividad: "El sistema devolvió exitosamente la actividad",
        rechazoExitosoActividad: "El sistema rechazó exitosamente la actividad",
        visador: "Visador",
        visar: "Visar",
        visarActividad: "Visar actividad",
        vistaDetallada: "Ver vista detallada",
        vistaGeneral: "Ver vista general",
        vistaPreviaMapaCalor: "Vista previa mapa de calor",
        vistaPreviaIndicador: "Vista previa indicador",
        vistaPreviaNoDisp: "Vista previa no disponible",
        vistas: "Vistas",
        visualizadores: "Visualizadores",
        y: "y",
        evolucionIndicador: "Evolución de indicador",
        exportacion: "Exportación",
        indicadores: "Indicadores",
        buscadorCompromisosProcesos: "Buscador de compromisos/procesos",
        buscadorProcesos: "Buscador de procesos",
        buscar: "Buscar",
        procesoParaCombinacionNoEncontrado: "No existe un proceso para la combinación dada",
        definicion: "Definición",
        responsables: "Responsables",
        umbrales: "Umbrales",
        listaResultados: "Lista de resultados",
        descargarIndicador: "Descargar indicador",
        tipoActividad: "Tipo de actividad",
        deseaSalirPagina: "¿Desea salir del sitio?",
        alertaPerdidaCambios: "Es posible que los cambios realizados no se guarden",
        oficios: "Oficios",
        oficioPadre: "Oficio padre",
        ofHijos: "Oficios hijos",
        tipoOficios: "Tipo oficios",
        estadoOficio: "Estado oficio",
        estadosOficio: "Estados oficio",
        estadoPlanAccion: "Estado plan acción",
        materias: "Materias",
        materia: "Materia",
        relacionUsuarioMateria: "Relación usuario/materia",
        relacionUsuarioTema: "Relación usuario/tema",
        relacionGerenciaAreaDocUsuario: "Relación gerencia/área doc./usuario",
        delitos: "Delitos",
        validarUsuarioMateria: "Se debe contar con un tema antes de crear la relación usuario/tema",
        listaRelacionesUsuarioMateria: "Lista de relaciones usuario/tema",
        listaRelacionesGerenciaAreaDocUsuario: "Lista de relaciones gerencia/área doc./usuario",
        editarOficio: "Editar oficio",
        nroOficioInterno: "N° oficio interno",
        validacionMateriaCrearOficio: "Se debe contar con un tema para crear el oficio",
        validacionTipoCrearOficio: "Se debe contar con un tipo para crear el oficio",
        validacionTipoEditarOficioAuto: "Se debe contar con un tipo para editar el oficio",
        nuevoOficio: "Nuevo oficio",
        guardarOficio: "Guardar oficio",
        archivoBorrado: "Archivo borrado",
        seguroDeseaEliminarOficio: "¿Estás seguro de que deseas eliminar el oficio",
        gestorOficios: "Gestor de oficios",
        gestorOficiosPendientesAuto: "Gestor oficios pendientes automatización",
        detalleDeOficio: "Detalle de oficio",
        asignaciones: "Asignaciones",
        oficio: "Oficio",
        oficioAsociado: "Oficio asociado",
        plazos: "Plazos",
        plazoActual: "Plazo actual",
        fechaSolicitud: "Fecha solicitud",
        plazoPropuesto: "Plazo propuesto",
        plazoRespuesta: "Plazo de respuesta",
        aprobar: "Aprobar",
        rechazarSolicitud: "Rechazar",
        detalleSolicitud: "Detalles de la solicitud",
        sinAccionesDisponibles: "Sin acciones disponibles",
        sinOficioRelacionado: "Sin oficio relacionado",
        aprobacionExitosa: "La solicitud se ha aprobado correctamente",
        rechazoExitoso: "La solicitud se ha rechazado correctamente",
        permiteReasignacion: "Permite reasignación",
        hrsParaReasignacion: "Hrs. para reasignación",
        nuevaAsignacion: "Nueva asignación",
        debeSeleccionarOficioCrearAct: "Debe seleccionar un oficio para crear una actividad",
        elaboracionRespuesta: "Elaboración de respuesta",
        verOficio: "Ver oficio",
        verArchivo: "Ver archivo",
        nroCarta: "N° carta",
        areasRequeridas: "Áreas requeridas",
        fechaSolInformacion: "Fecha sol. información",
        fechaRespuestaSolInfo: "Fecha respuesta sol. info.",
        rutsClientesInformados: "Ruts clientes informados",
        delitosAsociados: "Delitos asociados",
        canalEnvio: "Canal envío",
        enElaboracion: "En elaboración",
        seguroDeseaBorrarArchivo: "¿Seguro que desea borrar el archivo seleccionado?",
        detalleRespuesta: "Detalle respuesta",
        historialRespuestas: "Historial de respuestas",
        visacionRespuesta: "Visación de respuesta",
        misOficios: "Mis oficios",
        asignadorOficios: "Asignador de oficios",
        bibliotecaOficios: "Biblioteca de oficios",
        bibliotecaRespOficios: "Biblioteca respuestas Oficios",
        detalleAsignacion: "Detalle de asignación",
        arbolProcesos: "Arbol de procesos",
        arbolRelaciones: "Árbol de relaciones",
        verRiesgo: "Ver riesgo",
        verControl: "Ver control",
        sinControlesAsociados: "Sin controles asociados",
        expandir: "Expandir",
        contraer: "Contraer",
        relacionarNivel: "Relacionar nivel",
        mostrarCanceladas: "Mostrar canceladas",
        mayorIgualA: "Mayor igual a",
        menorIgualA: "Menor igual a",
        entre: "Entre",
        administrador: "Administrador",
        revisor: "Revisor",
        revisorActual: "Revisor actual",
        duenoControl: "Dueño de control",
        rInherente: "R. inherente",
        rResidual: "R. residual",
        activado: "Activo",
        perfilUsuario: "Perfil de usuario",
        configCuenta: "Configuración de cuenta",
        soloLectura: "Solo lectura",
        mostrarSoloEmpresaRel: "Mostrar datos solo de empresas relacionadas",
        inicioSesionProvCancelado: "Inicio de sesión con proveedor cancelado",
        ingreseCredParaContinuar: "Ingrese sus credenciales para continuar",
        seleccioneTenantParaContinuar: "Seleccione un tenant para continuar",
        iniciarSesion: "Iniciar Sesión",
        iniciaConProv: "Inicia sesión con algún proveedor",
        iniciarConMicrosoft: "Iniciar sesión con microsoft",
        iniciarConGoogle: "Iniciar sesión con google",
        solicitante: "Solicitante",
        bajo: "Bajo",
        medio: "Medio",
        alto: "Alto",
        muyAlto: "Muy Alto",
        aTiempo: "A tiempo",
        fueraDePlazo: "Fuera de plazo",
        cancelado: "Cancelado",
        alta: "Alta",
        media: "Media",
        baja: "Baja",
        noPermitido: "¡No permitido!",
        areaRestringida: "Área restringida",
        noTienePermisosSufientesAccesoPagina: "Usted no tiene los permisos suficientes para acceder a esta página. Pongase en contacto con el administrador.",
        sinLectores: "Sin lectores",
        sistema: "Sistema",
        importarResultados: "Importar resultados",
        delimitador: "Delimitador",
        formatoFecha: "Formato de fecha",
        aaaa: "AAAA",
        mm: "MM",
        dd: "DD",
        seleccioneCsvConResultados: "Seleccione CSV con resultados",
        descargarPlantilla: "Descargar plantilla",
        resultadoIndicadorFueraUmbralOsinComentario: "Resultado de indicador fuera de los umbrales establecidos o sin comentario en umbral 3",
        errorEnFila: "Error en fila",
        fechaExisteSobreescribir: "Resultado con fecha ya existe. Se reemplazará el valor",
        nuevoInicioSesion: "Nuevo inicio de sesión",
        registros: "Registros",
        historialEnvioCorreos: "Historial envíos de correos",
        sinNotificaciones: "Sin notificaciones",
        gestorMarcaciones: "Gestor de marcaciones",
        marcaciones: "Marcaciones",
        iniciarTrabajo: "Iniciar trabajo",
        tomarPausa: "Tomar pausa",
        finalizarJornada: "Finalizar jornada",
        cliente: "Cliente",
        proyecto: "Proyecto",
        reporteActivo: "Reporte activo",
        continuarTrabajo: "Continuar trabajo",
        trabajoRealizadoHastaMomento: "Describa el trabajo realizado hasta el momento",
        descripTrabajoRealizado: "Descripción del trabajo realizado",
        trabajoRealizado: "Trabajo realizado",
        validacionEmpresaCrearReporte: "Se debe contar con una empresa antes de crear un reporte",
        validacionProyectoCrearReporte: "Se debe contar con un proyecto antes de crear un reporte",
        codInforme: "Código informe",
        a: "A",
        distribucion: "Distribución",
        cc: "C.C.",
        nombreResponsable: "Nombre responsable",
        cargoResponsable: "Cargo responsable",
        reporteCumplimiento: "Reporte de cumplimiento",
        reporteDocumento: "Reporte de documentos",
        reporteRiesgos: "Reporte de riesgos",
        reporteEventosRiesgos: "Reporte eventos de riesgos",
        reporteIndicadores: "Reporte de indicadores",
        reporteOficios: "Reporte de oficios",
        tipoDocIntrNormNoEstabl: "Tipos de documentos Internos y Normativos no establecidos",
        configReportes: "Config. reportes",
        configArchivos: "Config. archivos",
        tipoDocInterno: "Tipo doc. interno",
        tipoDocNormativo: "Tipo doc. normativo",
        misReportes: "Mis reportes",
        generarReporte: "Generar Reporte",
        urlLogo: "URL de logo",
        horasTrab: "Horas trab.",
        controlClientes: "Control de Clientes",
        nuevoCliente: "Nuevo cliente",
        controlTipoProyectos: "Control de tipos de proyectos",
        nuevoTipoProyecto: "Nuevo tipo proyecto",
        listaClientes: "Lista de clientes",
        listaTiposProyectos: "Lista de tipos de proyecto",
        controlEtapas: "Control de Etapas",
        listaEtapas: "Lista de etapas",
        nuevaEtapa: "Nueva etapa",
        horasDuracion: "Horas duración",
        timeReport: "TimeReport",
        clientes: "Clientes",
        etapas: "Etapas",
        tiposProyecto: "Tipos de proyecto",
        proyectos: "Proyectos",
        controlProyectos: "Control de proyectos",
        listaProyectos: "Lista de proyectos",
        nuevoProyecto: "Nuevo proyecto",
        participantesProyecto: "Participantes de proyecto",
        nuevoReporte: "Nuevo reporte",
        cerrarProyecto: "Cerrar proyecto",
        incluirIndicadores: "Incluir indicadores",
        formatoReporte: "Formato Reporte",
        formatoA: "Formato A",
        formatoB: "Formato B",
        formatoC: "Formato C",
        formatoD: "Formato D",
        formatoE: "Formato E",
        listaRelacionesEmpresaUsuario: "Lista de relaciones empresa/usuario",
        relacionesEmpresaUsuario: "Relaciones empresa/usuario",
        listaRelacionesProyectoUsuario: "Lista de relaciones proyecto/usuario",
        relacionesProyectoUsuario: "Relaciones proyecto/usuario",
        validarEmpresaUsuario: "Se debe contar con una empresa antes de crear la relación empresa/usuario",
        liderProyecto: "Lider de proyecto",
        total: "Total",
        tipoDuracion: "Tipo de duración",
        fechaInicioPrev: "F. inicio",
        fechaTerminoPrev: "F. término prevista",
        hhUtilizadas: "HH Utilizadas",
        MostrarSoloIndicadores: "Mostrar solo indicadores",
        prioridad: "Prioridad",
        lista: "Lista",
        tablero: "Tablero",
        gestorTareasCortas: "Gestor de tareas cortas",
        gestorTareasYAcuerdos: "Gestor de tareas y acuerdos",
        nuevaTarea: "Nueva tarea",
        titulo: "Título",
        permiteExpiracion: "Permite expiración",
        detalleTarea: "Detalle de tarea",
        misTareas: "Mis Tareas",
        noIniciada: "No iniciadas",
        ejecutadas: "Ejecutadas",
        expiradas: "Expiradas",
        fechaCreacion: "Fecha creación",
        fechaModificacion: "Fecha modificación",
        docHijos: "Documentos hijos",
        justificacionProb: "Justificación de probabilidad",
        justificacionCons: "Justificación de impacto",
        gradoRiesgoInherente: "Grado de riesgo inherente",
        gradoRiesgoResidual: "Grado de riesgo residual",
        gradoRiesgoResidualDiseno: "Grado de riesgo residual (Diseño)",
        gradoRiesgoResidualReal: "Grado de riesgo residual (Real)",
        graficos: "Gráficos",
        calificacion: "Calificación",
        mitigacion: "Mitigación",
        ejecucion: "Ejecución",
        reasignar: "Reasignar",
        formatoActivos: "Formatos de activos",
        ubicacionActivos: "Ubicaciones de activo",
        ubicacion: "Ubicación",
        evaluacion: "Evaluación",
        nombrePlantilla: "Nombre de plantilla",
        nuevaPlantilla: "Nueva plantilla",
        auditoria: "Auditoría",
        nroAct: "N° de act.",
        predecesoras: "Predecesoras",
        importarActividades: "Importar actividades",
        agregarActividad: "Agregar actividad",
        seleccioneXlsxImpPlantillaAct: "Seleccione Excel (.xlsx) con lista de actividades a importar a la plantilla",
        fechaInicio: "F. inicio",
        fechaTermino: "F. término",
        avanceProyecto: "Avance del proyecto",
        plantilla: "Plantilla",
        ejecutorResponsable: "Ejecutor responsable",
        visadorResponsable: "Visador responsable",
        equipoProyecto: "Equipo de proyecto",
        notificarResponsables: "Enviar notificación a responsables (ejector y visador)",
        notificarEquipoProyecto: "Enviar notificación a equipo de proyecto",
        iniciarProyecto: "Iniciar proyecto",
        completarActividad: "Completar actividad",
        soloCompromisos: "Solo compromisos",
        soloProcesos: "Solo procesos",
        documentado: "¿Documentado?",
        afectaCons: "¿Afecta Impacto?",
        afectaProb: "¿Afecta Probabilidad?",
        sinDefinir: "Sin definir",
        interno: "Interno",
        externo: "Externo",
        internoYexterno: "Interno y externo",
        origen: "Origen",
        reasignaciones: "Reasignaciones",
        cargando: "Cargando...",
        formato: "Formato",
        duenoActivo: "Dueño de activo",
        calcularProb: "Calcular probabilidad",
        calcularCons: "Calcular impacto",
        seleccionar: "Seleccionar",
        calBaseGrupoCriterio: "Calculado en base a grupo de criterios",
        sinCriteriosConfigurados: "Sin criterios configurados",
        creaActCumplComprDoc: "Crea una actividad para cumplir con algún compromiso y/o documento",
        creaCtrlMitRiesgo: "Crea un control para mitigar un riesgo",
        creaActPlanAccAsocRiesgo: "Crea una actividad de plan de acción asociada a un riesgo",
        crearPlanAccionAsocIndicador: "Crear un plan de acción asociado a un indicador",
        crearPlanAccionAsocEvento: "Crear un plan de acción asociado a un evento",
        validarCompromisoCrearActividad: "La actividad debe estar asociada a un compromiso",
        generandoArchivo: "Generando archivo",
        incluirActComoLectorDueno: "Incluir actividades con rol de lector o dueño de control",
        horarios: "Horarios",
        controlHorarios: "Control de horarios",
        listaHorarios: "Lista de horarios",
        nuevoHorario: "Nuevo horarios",
        turnos: "Turnos",
        diaInicio: "Día inicio",
        diaTermino: "Día término",
        horaInicio: "Hora inicio",
        horaTermino: "Hora término",
        agregarRolPerfil: "Agregar rol a perfil",
        visadorActual: "Visador actual",
        gantt: "Gantt",
        mostrarVistaGantt: "Mostrar vista Gantt",
        reanudar: "Reanudar",
        incluirJustificacion: "Incluir Justificación",
        incluirRiesgosNoUtil: "Incluir riesgos no aplican",
        tipoGestionInterna: "Tipo de gestión interna",
        tema: "Tema",
        temas: "Temas",
        controlTemas: "Control de temas",
        listaTemas: "Lista de temas",
        nuevoTema: "Nuevo tema",
        nuevo: "Nuevo",
        nuevoControl: "Nuevo control",
        nuevoPlan: "Nuevo plan",
        control: "Control",
        requiereEjecutor: "¿Requiere ejecutor?",
        codInterno: "Código interno",
        cumplimiento: "Cumplimiento",
        riesgosEindicadores: "Riesgos e indicadores",
        ofiEnCurso: "Oficios en curso",
        ofiTotSiendoCursados: "Oficios totales siendo cursados",
        ofiTotEsperaAprob: "Oficios totales a la espera de aprobación",
        ofiTotEnEstadoEjecAtrasados: "Oficios totales en estado de ejecución atrasados",
        ofiTotProcVisacionAtrasados: "Oficios totales en proceso de visación atrasados",
        ofiAtiempo: "Oficios a tiempo",
        ofiAtrasados: "Oficios atrasados",
        ofiSiendoCursados: "Oficios siendo cursados",
        ofiAunNoHanSidoCerradas: "Oficios que aún no han sido cerrados",
        ofiEntregaFormaAtrasada: "Oficios entregados con retraso",
        ofiEsperaSerVisados: "Oficios en espera de ser visados",
        ofiQueSeEncuentranAtrasados: "Oficios que se encuentran atrasados",
        ofiAtrasadasPorVisar: "Oficios atrasados por visar",
        ofiTotRechazados: "Oficios totales rechazados",
        ofiVisadosAtiempo: "Oficios visados a tiempo",
        ofiVisadosConRetraso: "Oficios visados con retraso",
        descripcionMateria: "Descripción materia",
        descripcionMateriaPlaceholder: "Ingrese una descripción para la materia",
        controles: "Controles",
        soloRiesgosPlanAccion: "Solo riesgos con planes de acción",
        reporteControles: "Reporte de controles",
        reportePlanesAccion: "Reporte de planes de acción",
        reqRespuesta: "Requiere respuesta",
        reqGestion: "Requiere gestión",
        duenoDocumento: "Dueño de documento",
        plantillaRiesgos: "Plantilla de riesgos",
        agregarRiesgos: "Agregar riesgos",
        planAccion: "Plan de acción",
        planesAccion: "Planes de acción",
        filtrarPorInherente: "¿Filtrar por valor inherente?",
        filtrarPorResidual: "¿Filtrar por valor residual?",
        impacto: "Impacto",
        generarExcel: "Generar excel",
        procesoCritico: "Proceso crítico",
        configEvProcesosCriticos: "Config. evaluación procesos críticos",
        promediosRiesgoArbol: "Promedios de riesgo en el árbol de procesos",
        mostrarPromedioRiesgoNivel0: "Mostrar promedios de riesgo en Nivel 0",
        mostrarPromedioRiesgoNivel1: "Mostrar promedios de riesgo en Nivel 1",
        riesgosConsiderados: "riesgos considerados",
        metodologiaSinNombre: "Metodología",
        riesgoResidualMayorA: "Riesgo residual mayor a",
        riesgoInherenteMayorA: "Riesgo inherente mayor a",
        controlMayorA: "Control mayor a",
        reglasAplicadas: "Reglas aplicadas",
        o: "O",
        subTiposRiesgos: "Sub-tipos de riesgos",
        detalleControl: "Detalle de control",
        requiereEjecucion: "¿Requiere ejecución?",
        configEvRiesgosCriticos: "Config. evaluación riesgos críticos",
        mostrarPeriodicidadControl: "Mostrar periodicidad del riesgo al crear o editar controles",
        riesgoCritico: "Riesgo crítico",
        crearPlanAccion: "Crear plan de acción",
        indicadorCritico: "Indicador crítico",
        indicadorNormal: "Indicador normal",
        configEvIndicadoresCriticos: "Config. evaluación indicadores críticos",
        indicadorRojoMayorIgualA: "Indicador rojo mayor igual a",
        indicadorAmarilloMayorIgualA: "Indicador amarillo mayor igual a",
        oSi: "O si",
        agregarProceso: "Agregar proceso",
        sinProcesosAsociados: "Sin procesos asociados",
        quitarProceso: "Quitar proceso",
        seguroDeseaQuitarProcesoRiesgo: "¿Está seguro de que desea eliminar la evaluación del proceso sobre el riesgo?",
        valorInherente: "Valor inherente",
        calificacionProb: "Calificación Prob.",
        calificacionCons: "Calificación Cons.",
        procesoYaRegistrado: "Proceso ya se encuentra registrado en la lista",
        porRebajar: "Por rebajar",
        rebajador: "Rebajador",
        estadoRebaja: "Estado rebaja",
        fechaRebaja: "Fecha rebaja",
        oficiosEnCurso: "Oficios en curso",
        oficiosPorVisar: "Oficios por visar",
        oficiosPorRebajar: "Oficios por rebajar",
        prorroga: "Prórroga",
        solicitudProrroga: "Solicitud de prórroga",
        solicitudesProrroga: "Solicitudes de prórroga",
        actInactivaSolicitudProrroga: "La asignación se habilitará cuando la solicitud de prórroga sea evaluada por visador",
        solicitudProrrogaExitosa: "Solicitud de prórroga enviada",
        nadaPorRebajar: "Nada por rebajar",
        rebajaExitosa: "El sistema rebajó exitosamente el oficio",
        rebajaRespuesta: "Rebaja de respuesta",
        rebajar: "Rebajar",
        eventoRiesgo: "Evento de riesgo",
        nuevoEventoRiesgo: "Nuevo evento de riesgo",
        editarEventoRiesgo: "Editar evento de riesgo",
        afectacion: "Afectación",
        detalleEvento: "Detalle del evento",
        nroAfectados: "N° de afectados",
        montoProvision: "Monto provisión",
        montoPerdida: "Monto perdida",
        informacionReporte: "Información reporte",
        fechaOcurrencia: "Fecha ocurrencia",
        fechaDeteccion: "Fecha detección",
        fechaSolucion: "Fecha solución",
        reportador: "Reportador",
        areasAfectadas: "Áreas afectadas",
        nuevoEvento: "Nuevo evento",
        areaReportador: "Área usuario que reporta",
        riesgoMaterializado: "Riesgo materializado",
        validarProcesoCrearControl: "Control debe estar asociada a un proceso o activo",
        validarProcesoCrearPlanAccion: "Plan acción debe estar asociada a un proceso o activo",
        plantillaControles: "Plantilla de controles",
        listaControles: "Lista de controles",
        relacionar: "Relacionar",
        relacionControlProcesoRiesgo: "Relacionar controles/procesos/riesgos",
        depPlantilla: "Dependiente de plantilla",
        seguroDeseaGuardarControlRelacion: "Control se encuentra relacionado a una plantilla, si lo edita se perderá la relación. ¿Estás seguro de que deseas guardar cambios?",
        actividadesControles: "Actividades/Controles",
        listaOficios: "Lista de oficios",
        listaAsigOficios: "Lista de asignación oficios",
        requiereResponsableGrc: "¿Requiere responsable en GRC?",
        requiereEjecucionGrc: "¿Requiere ejecución en GRC?",
        totalElementos: "Total de elementos",
        descargarDesde: "Descargar desde",
        hasta: "Hasta",
        validacionMaxRangosExportador: "Limite máximo de descarga es de 5000 elementos",
        validacionRangosExportador: "Rango 'desde' y 'hasta' debe ser mayor a cero",
        tenant: "Tenant",
        asignacionMasivaPorTema: "Asignación masiva por tema",
        asignacionExitosa: "Asignación exitosa",
        tipoGestion: "Tipo gestión",
        usarPlazoRespOficios: "Usar plazo de respuesta de cada oficio",
        ingresosDiariosUltimos30Dias: "Ingresos diarios últimos 30 días",
        nroCodigos: "Cant. de códigos",
        generarCodigos: "Generar códigos",
        nuevaSolicitud: "Nueva solicitud",
        cantidad: "Cantidad",
        id: "Id",
        oficiosCargados: "Oficios cargados",
        oficiosAsignados: "Oficios asignados",
        oficiosSinAsignar: "Oficios sin asignar",
        ofiTotCargadosGrc: "Oficios totales creados en GRC",
        ofiTotAsignadosGrc: "Oficios totales asignados en GRC",
        ofiTotSinAsignarGrc: "Oficios totales sin asignar en GRC",
        correlativoEnviadoEmailExitoso: "Correlativos enviados a su correo electrónico exitosamente",
        rebajarOficios: "Rebajar oficios",
        fechaVencAsignacion: "Fecha venc. asignación",
        fechaVencOficio: "Fecha venc. oficio",
        utilizar: "Utilizar",
        cargarArchivoAdic: "Cargar archivo adicional",
        registroErrores: "Registro de errores",
        cargaOficiosAuto: "Carga de oficios automatizada",
        pendientesCargaOficiosAuto: "Pendientes carga automatizada oficios",
        historicoCargaOficiosAuto: "Histórico carga automatizada oficios",
        erroresCargaOficiosAuto: "Errores en carga automatizada oficios",
        controlCiclosAud: "Control de ciclos de auditoría",
        desde: "Desde",
        anios: "Años",
        revisado: "Revisado",
        revisionProcesosCiclo: "Revisión procesos/ciclo",
        importarRevisiones: "Importar revisiones",
        reporteActivosInf: "Reporte activos",
        reporteIncidencias: "Reporte de incidencias",
        limitarReporte: "Limitar reporte",
        SeDebeLimitarMapaCalor: "Debe reducir los riesgos a un nivel inferior a 350 para poder generar el reporte",
        usuariosOperativos: "Usuarios operativos",
        usuariosInformativos: "Usuarios informativos",
        usrOperativosDescrip: "Usuarios que se autentican con el sistema y realizan tareas o procesos específicos",
        usrInformativosDescrip: "Usuarios que solo se utilizan como referencia y no necesitan registrarse ni iniciar sesión",
        nuevoUsuarioOperativo: "Nuevo usuario operativo",
        nuevoUsuarioInformativo: "Nuevo usuario informativo",
        convertirEnUsuarioOperativo: "Convertir en usuario operativo",
        convertirEnUsuarioInformativo: "Convertir en usuario informativo",
        organigrama: "Organigrama",
        organigramaEmpresa: "Organigrama de la empresa",
        cargo: "Cargo",
        configSistema: "Configs sistema",
        configCumplimiento: "Configs cumplimiento",
        configRiesgos: "Configs riesgos",
        configActivosInf: "Configs activos de inf.",
        configOficios: "Configs oficios",
        configFirmas: "Configs firmas",
        configChatbot: "Configs chatbot",
        configAuditorias: "Configs auditorías",
        configTimeReport: "Configs timeReport",
        configSistemaDescrip: "Ajustes generales de usuarios, bibliotecas, notificaciones y roles",
        configCumplimientoDescrip: "Ajustes relacionados con documentos, compromisos y actividades",
        configRiesgosDescrip: "Ajustes relacionados con procesos, riesgos y seguimiento",
        configActivosInfDescrip: "Ajustes de tipos, formatos y ubicaciones de activos",
        configOficiosDescrip: "Ajustes de oficios, importadores y rebajadores",
        configAuditoriasDescrip: "Ajustes de ciclos, planes, auditorías y seguimiento",
        configTimeReportDescrip: "Ajustes relacionados al reporte de horas",
        configChatbotDescrip: "Ajustes y configuraciones relacionadas al chatbot",
        configDirectorios: "Configs directorios",
        configDirectorioDescrip: "Ajustes relacionados a comités, actas y sesiones de directorio",
        estructura: "Estructura",
        reabrir: "Reabrir",
        seguroDeseaReabrirOficio: "¿Estás seguro de que deseas reabrir la respuesta? Esta acción devolverá la respuesta al ejecutor",
        camposIncompletos: "Campos incompletos",
        sinArchivos: "Sin archivos",
        borrador: "Borrador",
        modifDoc: "Modificación de documento",
        creacionDoc: "Creación de documento",
        solicitudesDocumentos: "Solicitudes de documentos",
        preRevision: "Pre-revisión",
        ratingCriticidadInherente: "Rating criticidad inherente",
        ratingCriticidadResidual: "Rating criticidad residual",
        performanceControles: "Desempeño controles",
        eventosRiesgosPorPeriodo: "Eventos de riesgos por periodo",
        perdidaEventosRiesgosPorPeriodo: "Perdidas eventos por periodo",
        indicadoresPorPeriodo: "Indicadores por periodo",
        busquedaAvanzada: "Búsqueda avanzada",
        solicitarReasignacion: "Solicitar reasignación",
        gestorSolicitudesReasignacion: "Gestor de solicitudes de reasignación",
        ingreseMotivoSolicitud: "Ingrese motivo de solicitud",
        solicitar: "Solicitar",
        solicitudExitosa: "Solicitud enviada exitosamente",
        actInactivaSolicitudReasignacion: "La asignación se habilitará cuando la solicitud de reasignación sea evaluada por visador",
        rechazarYdevolver: "Rechazar y devolver",
        solicitudAprobadaExitosa: "Solicitud aprobada exitosamente",
        solicitudRechazadaExitosa: "Solicitud rechazada exitosamente",
        ejecutorInicial: "Ejecutor inicial",
        seguroDeseaAprobarReasignacion: "¿Está seguro que desea aprobar la reasignación del oficio?",
        seguroDeseaRechazarReasignacion: "¿Está seguro que desea rechazar la reasignación del oficio?",
        justificacion: "Justificación",
        aprobador: "Aprobador",
        fechaAprobacion: "Fecha de aprobación",
        validacionGerencia: "Se debe contar con una gerencia para continuar",
        validacionCampos: "Los campos obligatorios no pueden estar vacíos",
        tiposRiesgosMat: "Tipos de riesgos materializados",
        riesgosMat: "Riesgos materializados",
        procesosAfectados: "Procesos afectados",
        seguroDeseaEliminar: "¿Estás seguro de que deseas eliminar",
        validacionPlantillaCrearEvaluacion: "Se debe contar con una plantilla antes de crear evaluación",
        validacionResponsablesEvaluacion: "Se debe asignar ejecutores/visadores para todos los controles",
        configAssessment: "Configs assessment",
        configAssessmentDescrip: "Ajustes relacionados a plantillas de criterios de evaluación",
        assessment: "Asessment",
        plantillasEvaluaciones: "Plantillas de evaluaciones",
        nuevaEvaluacion: "Nueva evaluación",
        gestorEvaluaciones: "Gestor de evaluaciones",
        preguntas: "Preguntas",
        pregunta: "Pregunta",
        sinElementos: "Sin elementos",
        finalizadas: "Finalizadas",
        misEvaluaciones: "Mis evaluaciones",
        finalizada: "Finalizada",
        criterios: "Criterios",
        puntaje: "Puntaje",
        indiceVcdb: "Índice VCDB",
        puntajeExpectativa: "Puntuación de expectativa",
        impactoMision: "Impacto a la misión",
        impactoObjOp: "Impacto en objs. operativos",
        impactoObligs: "Impacto en las obligaciones",
        puntajeRiesgo: "Puntaje de riesgo",
        nivelRiesgo: "Nivel de riesgo",
        alcance: "Alcance",
        riesgoAbordado: "Riesgo abordado",
        riesgoAceptado: "Riesgo aceptado",
        politicasAprobadas: "Políticas aprobadas",
        controlesImplementados: "Controles implementados",
        controlesAutomatizados: "Controles automatizados",
        controlesReportados: "Controles reportados",
        auditorias: "Auditorías",
        aceptarCompromiso: "Aceptar compromiso",
        editarAuditoria: "Editar auditoría",
        errorFaltaArchivoAdjunto: "Debe ingresar un archivo adjunto para continuar",
        errorNombrePlantilla: "Debe ingresar un nombre de plantilla para continuar",
        errorPlanAuditoria: "Se debe seleccionar un plan de auditoría",
        errorTipoAuditoria: "Se debe seleccionar un tipo de auditoría",
        gestorPlanesAuditoria: "Gestor planes de auditoría",
        gestorAuditorias: "Gestor auditorías",
        misAuditorias: "Mis auditorías",
        misPruebasAuditorias: "Mis pruebas de auditoría",
        misRecomendaciones: "Mis recomendaciones",
        misCompromisos: "Mis compromisos",
        misHoras: "Mis Horas",
        importacionAuditorias: "Importación de auditorías",
        importacionActPreliminares: "Importación de act. preliminares",
        importacionActivosInf: "Importación activos de información",
        importacionAdtCompromisos: "Importación compromisos auditoría",
        ingreseDescripAdtArea: "Ingrese una descripción para el área de auditoría",
        ingreseDescripAdtTipoAuditoria: "Ingrese una descripción para el tipo de auditoría",
        ingreseDescripAdtTipoTrabajo: "Ingrese una descripción para el tipo de trabajo",
        nuevoTipoAuditoria: "Nuevo tipo de auditoría",
        nuevoTipoTrabajo: "Nuevo tipo de trabajo",
        nuevoAuditoria: "Nueva auditoría",
        tiposTrabajo: "Tipos de trabajo",
        tiposAuditoria: "Tipos de auditoría",
        etapaCargaHoras: "Etapas carga de horas",
        tareaCargaHoras: "Tareas carga de horas",
        validacionPlan: "Se debe contar con un plan para continuar",
        sabado: "Sabado",
        domingo: "Domingo",
        controlAdtAreas: "Control de áreas auditoría",
        controlAdtTipoTrabajos: "Control de tipos de trabajo",
        controlAdtTipoAuditorias: "Control de tipos de auditoría",
        controlAdtCriticidadHallazgos: "Control de criticidades de hallazgos",
        controlAdtEtapaCargaHoras: "Control de etapas en carga de horas",
        controlAdtTareaCargaHoras: "Control de tareas en carga de horas",
        criticidadesHallazgosAdt: "Criticidades de hallazgos",
        listaAdtAreas: "Lista de áreas auditoría",
        listaAdtTiposAuditoria: "Lista de tipos de auditoría",
        listaAdtTiposTrabajo: "Lista de tipos de trabajo",
        listaAdtAdtEtapaCargaHoras: "Lista de etapas",
        listaAdtCriticidadHallazgos: "Lista de criticidades hallazgos",
        listaAdtAdtTareaCargaHoras: "Lista de tareas",
        anio: "Año",
        tipoAuditoria: "Tipo auditoría",
        tipoTrabajo: "Tipo trabajo",
        fechaPresComite: "Fecha presentación comité",
        horasAsign: "Horas asignadas",
        horasQa: "Horas QA",
        auditorLider: "Auditor lider",
        auditor: "Auditor",
        auditores: "Auditores",
        auditoresQa: "Auditores QA",
        fechaInicioReal: "Fecha inicio real",
        fechaInfPreliminar: "Fecha inf. preliminar",
        fechaInfFinal: "Fecha informe final",
        planAuditoria: "Plan de auditoría",
        plan: "Plan",
        editarPlan: "Editar plan",
        planes: "Planes",
        objetivoGeneral: "Objetivo general",
        docFuenteInfo: "Documentación / Fuente de información",
        actividadesPreliminares: "Act. preliminares",
        iniciarAuditoria: "Iniciar auditoría",
        tipoEvidencia: "Tipo evidencia",
        reqAprobQa: "Req. aprob. QA",
        reqAprobJefatura: "Req. aprob. jefatura",
        reqAprobGerente: "Req. aprob. gerente",
        interaccion: "Interacción",
        seguimiento: "Seguimiento",
        aprobQa: "Aprob. QA",
        aprobJefatura: "Aprob. Jefatura",
        aprobGerente: "Aprob. Gerencia",
        plActPrelimNoConfiguradas: "Plantillas de actividades preliminares no configuradas",
        seguroIniciarAuditoria: "¿Está seguro que desea iniciar la auditoría?",
        seguroIniciarEvaluacion: "¿Está seguro que desea iniciar la evaluación?",
        hallazgos: "Hallazgos",
        opMejoras: "Oportunidades de mejoras",
        prueba: "Prueba",
        pruebas: "Pruebas",
        completarPrueba: "Completar prueba",
        visarPrueba: "Visar prueba",
        nuevaPrueba: "Nueva prueba",
        editarPrueba: "Editar prueba",
        directas: "Directas",
        indirectaNoCargables: "Indirectas y no cargables",
        totalSemana: "Total semana",
        totalHorasDirectas: "Total horas directas",
        totalHorasIndNoCarg: "Total horas ind./No carg.",
        horasCargar: "Horas a cargar",
        diferencia: "Diferencia",
        recomendacion: "Recomendación",
        sinHallazgos: "Sin hallazgos disponibles",
        recomendaciones: "Recomendaciones",
        jefatura: "Jefatura",
        entregable: "Entregable",
        enRevision: "En revisión",
        compSiendoCursadas: "Compromisos siendo cursados",
        compEsperaAprob: "Compromisos a la espera de aprobación",
        compAunNoHanSidoCerradas: "Compromisos que aún no han sido cerradas",
        compATiempo: "Compromisos a tiempo",
        compAtrasados: "Compromisos atrasados",
        compVisadosAtiempo: "Compromisos visados a tiempo",
        compVisadosConRetraso: "Compromisos visados con retraso",
        compEsperaSerVisados: "Compromisos en espera ser visados",
        compQueSeEncuentranAtrasados: "Compromisos que se encuentran atrasados",
        compTotRechazados: "Compromisos totales rechazados",
        compQueSeEncuentranEnProrroga: "Compromisos que se encuentran en prórroga",
        seguroDeseaEliminarPrueba: "¿Estás seguro de que deseas eliminar la prueba",
        seguroDeseaAprobar: "¿Estás seguro de que deseas aprobar?",
        seguroDeseaDevolverEjecutor: "¿Estás seguro de que deseas devolver al ejecutor?",
        gestorReglasAuditoria: "Gestor de reglas de auditoría",
        nuevaRegla: "Nueva regla",
        alertasNuevas: "Alertas nuevas",
        nombreRegla: "Nombre de regla",
        regla: "Regla",
        detalleRegla: "Detalle de regla",
        descargarRegla: "Descargar regla",
        reglaCritica: "Regla crítica",
        reglaNormal: "Regla normal",
        evolucionRegla: "Evolución de regla",
        vistaPreviaRegla: "Vista previa de regla",
        tipoRegla: "Tipo de regla",
        reporteReglasAuditoria: "Reporte de reglas auditoría",
        reporteAuditoriaInterna: "Reporte de auditorías interna",
        misReglasAuditoria: "Mis reglas de auditoría",
        reglasPorRevisar: "Reglas por revisar",
        ingreseCodigo: "Ingrese codigo",
        importacionReglasAdt: "Importación reglas de auditoría",
        actualizacionReglasAdt: "Actualización reglas auditoría",
        seguroDeseaEnviarSolicitudProrroga: "¿Estás seguro de que deseas enviar la solicitud de prórroga?",
        solicitudesProrrogasCompromisos: "Solicitudes prórrogas de compromisos",
        evaluar: "Evaluar",
        visarProroga: "Visar prórroga",
        aprobarYmodificar: "Aprobar y modificar",
        modificar: "Modificar",
        apruebaCambiandoFechaPropuesta: "Aprueba cambiando fecha propuesta",
        apruebaProrroga: "Aprueba la prórroga",
        rechazaProrroga: "Rechaza la prórroga",
        compRequeridoContinuar: "Se requiere seleccionar un compromiso antes de continuar",
        misSolicitudesProrroga: "Mis solicitudes de prórroga",
        fechaEvaluacionComite: "Fecha evaluación comité",
        configFirma: "Config. firma",
        seguroDeseaEliminarPlantilla: "¿Estás seguro de que deseas eliminar la plantilla",
        propuesta: "Propuesta",
        revisores: "Revisores",
        visadores: "Visadores",
        debeSeleccionarRevisores: "Debe seleccionar al menos un revisor",
        debeSeleccionarVisadores: "Debe seleccionar al menos un visador",
        version: "Versión",
        rechazaYdevuelveActAlSolicitante: "Rechazar y devolver al solicitante",
        rechazarSolicitante: "Devolver a solicitante",
        cargarNuevaVersionDoc: "¿Cargar nueva versión del documento?",
        efecto: "Efecto",
        marcoNormativo: "Marco normativo",
        documentarPapelTrabajo: "Documentar papel de trabajo",
        auditoriasDirectas: "Auditorías directas",
        horasDirIndNoCarg: "Horas directas, indirectas y no cargables",
        gerenteAuditoria: "Gerente auditoría",
        gerenciaContraparte: "Gerencia contraparte",
        gerenteContraparte: "Gerente contraparte",
        aprobAuditorLider: "Aprob. Auditor líder",
        actFormaParteInteracion: "Actividad es obligatoria debido a que forma parte de una interacción",
        misHallazgos: "Mis hallazgos",
        hallazgo: "Hallazgo",
        rechazado: "Rechazado",
        accionRequerida: "Acción requerida",
        auditoriaSinQa: "Auditoría no cuenta con auditores QA",
        papelTrabajo: "Papel de trabajo",
        detalleCambios: "Detalle de cambios",
        cargarArchivo: "Cargar archivo",
        suplente: "Suplente",
        administradorCumplimiento: "Admin cumplimiento",
        administradorOficios: "Admin oficios",
        administradorRiesgos: "Admin riesgos",
        administradorAuditoria: "Admin auditoría",
        nuevoHallazgo: "Nuevo hallazgo",
        emisor: "Emisor",
        correccion: "Corrección",
        causaRaiz: "Causa raíz",
        metodoUtilizado: "Método utilizado",
        controlOrigenesHallazgos: "Control de orígenes de hallazgos",
        controlTiposHallazgos: "Control de tipos de hallazgos",
        controlEmisoresHallazgos: "Control de emisores de hallazgos",
        listaOrigenesHallazgos: "Lista de orígenes de hallazgos",
        listaTiposHallazgos: "Lista de tipos de hallazgos",
        listaEmisoresHallazgos: "Lista de emisores de hallazgos",
        origenes: "Orígenes",
        tipoHallazgos: "Tipos hallazgos",
        emisores: "Emisores",
        ggYgo: "GG/GO",
        fechaVerificacion: "Fecha verificación",
        ejecutorPlanAccion: "Ejecutor plan de acción",
        aprobadorPlanAccion: "Aprobador plan de acción",
        revision: "Revisión",
        fechaRealCierre: "Fecha real de cierre",
        reqReEvaluacion: "¿Requiere re-evaluación?",
        comentarioAdic: "Comentarios adic.",
        sinCompromisos: "Sin compromisos",
        sinRecomendaciones: "Sin recomendaciones",
        fechaIdentificacion: "Fecha de identificación",
        mostrarFechaResultados: "Mostrar fecha en resultados",
        aprobGerenteAuditoria: "Aprob. Gerente Auditoría",
        enAprobCompromiso: "En aprob. Compromiso",
        enRevAuditoria: "En rev. Auditoría",
        factorProb: "Factor prob.",
        factorCons: "Factor cons.",
        maxEscalones: "Máx. Escalones",
        factorIndiceRiesgos: "Factor índices riesgos",
        controlFactorIndiceRiesgos: "Control de Factor índices riesgos",
        nuevoFactor: "Nuevo factor",
        iteracion: "Iteración",
        fechaReporte: "Fecha reporte",
        actualizaDocumentoAsoc: "¿Actualiza documento asociado?",
        nuevaJustificacion: "Nueva justificación",
        justifReglas: "Justificaciones reglas de auditoría",
        aprobadas: "Aprobadas",
        crearJustif: "Crear justificación",
        enviarRecomendaciones: "Enviar recomendaciones",
        seguroDeseaEjecutarAccion: "¿Seguro que desea ejecutar acción?",
        tipoDato: "Tipo de dato",
        reporteAssessment: "Reporte de evaluaciones",
        fechaCierreEfectivo: "Fecha cierre efectivo",
        puntoNorma: "Punto norma",
        planeacion: "Planeación",
        comunicacion: "Comunicación",
        pruSiendoCursadas: "Pruebas siendo cursadas",
        pruEsperaAprob: "Pruebas a la espera de aprobación",
        compEnCurso: "Compromisos siendo cursados",
        consideraciones: "Consideraciones",
        aprobadores: "Aprobadores",
        misActPreliminares: "Mis actividades preliminares",
        emisionRecomendaciones: "Emisión de recomendaciones",
        creacionCompromiso: "Creación compromiso",
        aprobacionCompromiso: "Aprobación compromiso",
        compromisoCompletado: "Compromiso completado",
        cierreCompromiso: "Cierre compromiso",
        aprobacionProrroga: "Aprobación prórroga",
        rechazoProrroga: "Rechazo prórroga",
        reporteHallazgos: "Reporte de hallazgos",
        abierto: "Abierto",
        cerrado: "Cerrado",
        tareasPendContraparte: "Tareas pendientes por contraparte",
        tareasPendAudContinua: "Tareas pendientes por auditoría continua",
        accionPrevia: "Acción previa",
        seguroMarcarAccionPrevia: "¿Seguro que desea marcar como acción previa?",
        nuevoComite: "Nuevo comité",
        nuevaSesion: "Nueva sesión",
        nuevoActa: "Nuevo acta",
        presidente: "Presidente",
        vicepresidente: "Vicepresidente",
        directores: "Directores",
        secretario: "Secretario",
        comite: "Comité",
        comites: "Comités",
        sesiones: "Sesiones",
        actas: "Actas",
        gestorComites: "Gestor de comités",
        gestorSesiones: "Gestor de sesiones",
        gestorActas: "Gestor de actas",
        bandejasDoc: "Bandejas documento",
        listaBandejas: "Lista de bandejas",
        relacionBandejaUsuario: "Relación bandeja/usuario",
        metodologia: "Metodología",
        validaFechaMenorFechaActual: "La fecha no debe ser anterior a la fecha actual",
        contrato: "Contrato",
        contratos: "Contratos",
        gestorContratos: "Gestor de contratos",
        nuevoContrato: "Nuevo Contrato",
        editarContrato: "Editar Contrato",
        fechaFin: "F. fin",
        monto: "Monto",
        moneda: "Moneda",
        monedas: "Monedas",
        categoria: "Categoría",
        contacto: "Contacto",
        categoriasContratos: "Categorías contratos",
        contraparte: "Contraparte",
        contrapartesContratos: "Contrapartes contratos",
        configContratos: "Configs contratos",
        configContratosDescrip: "Ajustes relacionados a templates y contratos",
        controlCntCategorias: "Control de categorías contratos",
        listaCntCategorias: "Lista de categorías contratos",
        nuevaCategoria: "Nueva categoría",
        controlCntMonedas: "Control de monedas",
        listaCntMonedas: "Lista de monedas",
        nuevaMoneda: "Nueva moneda",
        controlCntContrapartes: "Control de contrapartes",
        listaCntContrapartes: "Lista de contrapartes",
        nuevaContraparte: "Nueva contraparte",
        versionesContratos: "Versiones de contratos",
        codigoContrato: "Cód. contrato",
        sinContratoRelacionado: "Sin contrato relacionado",
        versiones: "Versiones",
        contactosProveedor: "Contactos de proveedor",
        controlContactosContraparte: "Control de contactos de contraparte",
        listaContactosContraparte: "Lista de contactos contraparte",
        nuevoContacto: "Nuevo contacto",
        nuevaVersionContrato: "Nueva versión contrato",
        duenoContrato: "Dueño de contrato",
        misContratos: "Mis contratos",
        pagosContrato: "Pagos de contrato",
        nuevoPago: "Nuevo pago",
        controlTiposVersiones: "Control de tipos de versiones contratos",
        listaTiposVersiones: "Lista de tipos de versiones contratos",
        nuevoTipoVersion: "Nuevo tipo de versión",
        tiposVersiones: "Tipos de versiones",
        tipoVersion: "Tipo de versión",
        aprobados: "Aprobados",
        rechazados: "Rechazados",
        rechazarContrato: "Rechazar",
        gestorFirma: "Gestor de firmas",
        misFirmas: "Mis firmas",
        nuevoDocFirma: "Nuevo documento por firmar",
        tipoFirma: "Tipo de firma",
        firmante: "Firmante",
        firmantes: "Firmantes",
        firmas: "Firmas",
        controlFirmantes: "Control de firmantes",
        configuracionFirmas: "Configuración de firmas",
        configFirmasDescrip: "Ajustes de firmantes y tipos de firma",
        nuevoFirmante: "Nuevo firmante",
        primerApellido: "Primer apellido",
        segundoApellido: "Segundo apellido",
        rut: "Rut",
        esUsuarioExterno: "¿Es usuario externo?",
        apellidos: "Apellidos",
        firmanteRequerido: "Se requiere seleccionar un firmante para continuar",
        tiposDocFirma: "Tipos de documentos firma",
        clasificacionDocFirma: "Clasificación de documento firma",
        clasificacionesDocFirma: "Clasificaciones de documento firma",
        controlClasificacionesDocFirma: "Control clasificaciones de documentos firma",
        listaClasificacionesDocFirma: "Lista de clasificaciones de documentos firma",
        visacionExitosaDocFirma: "El sistema visó exitosamente el documento a firmar",
        devueltaExitosoDocFirma: "El sistema devolvió el documento a firmar",
        rechazoExitosoDocFirma: "El sistema rechazó exitosamente el documento a firmar",
        tipoSesion: "Tipo de sesión",
        sesion: "Sesión",
        nuevaSesionComite: "Nueva sesión de comité",
        temasTratados: "Temas tratados",
        acuerdos: "Acuerdos",
        acta: "Acta",
        nuevaActaSesion: "Nueva acta de sesión",
        tipoActa: "Tipo de acta",
        proximasRepeticionesActividades: "Próximas repeticiones de actividades",
        controlCategoriasRiesgos: "Control categorías riesgos",
        listaCategorias: "Lista de categorías",
        nuevoCategoria: "Nueva categoría",
        aprobacionExitosaOficios: "Aprobación exitosa de los oficios",
        prioridadUrgente: "Prioridad Urgente",
        prioridadAlta: "Prioridad Alta",
        prioridadNormal: "Prioridad Normal",
        prioridadBaja: "Prioridad Baja",
        tareasCompletadas: "Tareas Completadas",
        tareasExpiradas: "Tareas Expiradas",
        tareasYAcuerdos: "Tareas y acuerdos",
        misTareasYAcuerdos: "Mis tareas y acuerdos",
        enVisacion: "Tareas en proceso de visación",
        enEsperaDeEjecutor: "En espera de ejecutor",
        tareasRechazadas: "Tareas Rechazadas por Visador",
        tareasVisadasCompletadas: "Tareas Visadas Completadas",
        tareasVisadasYCerradas: "Tareas y Acuerdos que fueron Visados y Cerrados",
        tareasCerradas: "Tareas Visadas y Cerradas",
        esperandoAsignacion: "Esperando asignación o inicio por parte del ejecutor",
        revisadasVisacion: "Pendientes de revision por el visador para su aprobación",
        requierenCorreccion: "Requieren corrección o revisión antes de continuar",
        finalizadasYaprobadas: "Finalizadas y aprobadas correctamente",
        tareasYAcuerdosCompletados: "Tareas y acuerdos completados",
        seguroMarcarHallazgo: "¿Seguro que desea marcar como hallazgo?",
        seguroMarcarRecomendacion: "¿Seguro que desea marcar como recomendacion?",
        seguroMarcarCompromiso: "¿Seguro que desea marcar como compromiso?",
        proximasRepeticionesControles: "Próximas repeticiones de controles",
        docPlanAccionPadre: "Plan de acción padre",
        prorrogaEnCurso: "Prórroga en curso",
        jsonInvalido: "JSON inválido",
        faltanCampos: "Faltan campos",
        seleccJsonCredGoogleDrive: "Carga el archivo JSON de credenciales de Google Drive",
        ingresados: "Ingresados",
        enCursoPlanAccion: "Plan de acción en curso",
        enAprobPlanAccion: "Plan de acción en aprobación",
        finalizados: "Finalizados",
        incluirPlanAccionExcel: "Incluir plan de acción (Excel)",
        reintentarEnvioExitoso: "Se ha reintentado exitosamente el envio del oficio",
        plantillaVacia: "Plantilla vacía",
        plantillaConDatos: "Plantilla con datos",
        agregarRelacion: "Agregar relación",
        modificarTema: "Modificar tema",
        prorrogas: "Prórrogas",
        prorrogasPorGerencia: "Prórrogas por gerencia",
        lugar: "Lugar",
        enprorroga: "En prórroga",
        avance: "Avance",
        porAvanceEntrega: "Porcentaje de avance de entrega",
        considerar: "Considerar",
        incluir: "Incluir",
        soloLunesViernes: "Sólo de lunes a viernes",
        semanaCompleta: "Semana completa",
        repCumplimientoAcuerdos: "Reporte de cumplimiento de acuerdos",
        conclusiones: "Conclusiones",
        bandejasDocumentos: "Bandejas de documentos",
        sinBandejaAsignada: "Sin bandeja asignada",
        sinAsignar: "Sin asignar",
        reglasAuditoria: "Reglas de auditoría",
        modificacionMasivaEstadoAdtCompromisos: "Modificación de estados compromisos",
        modificacionMasiva: "Modificación masiva",
        estadoActual: "Estado actual",
        nuevoEstado: "Nuevo estado",
        seguroDeseaModificarEstadoAdtCompromiso: "¿Estás seguro de que deseas modificar? Esta acción podría reiniciar las aprobaciones del compromiso",
        modificacionExitosaCompromisos: "Compromisos modificados exitosamente",
        activos: "Activos",
        agregarActivo: "Agregar activo",
        buscadorActivos: "Buscador de activos",
        sinActivosAsociados: "Sin activos asociados",
        quitarActivo: "Quitar activo",
        activoYaRegistrado: "Activo ya se encuentra registrado en la lista",
        activoParaCombinacionNoEncontrado: "No existe un activo para la combinación dada",
        seguroDeseaQuitarActivoRiesgo: "¿Está seguro de que desea eliminar la evaluación del activo sobre el riesgo?",
        seguroDeseaConfirmarDocSolSinRevisores: "¿Estás seguro de que deseas confirmar la revisión sin flujo de aprobación? Esta acción guardará los cambios en gestor de documentos.",
        debeSeleccionarEjecutorPlanAccion: "Debe seleccionar un ejecutor para crear el plan de acción",
        soloEntregaParcial: "Solo entrega parcial",
        permitirControlesDuplicados: "Permitir controles duplicados",
        detallePermitirControlesDuplicados: "Si se activa, los controles con códigos existentes se duplicarán al importar nuevamente la misma planilla",
        grupo: "Grupo",
        gruposActivos: "Grupos de activos",
        dimensionesAfectadas: "Dimensiones afectadas",
        gestionPlantillasFlujo: "Gestión de plantillas de flujo",
        nuevaPlantillaFlujo: "Nueva plantilla de flujo",
        plantillasFlujo: "Plantillas de flujo",
        reintentar: "Reintentar",
        seguroDeseaEliminarMensaje: "¿Estás seguro de que deseas eliminar el mensaje de error?",
        evaluacionTecnica: "Técnica",
        evaluacionOrganizacional: "Organizacional",
        auditorResponsable: "Auditor responsable",
        pausar: "Pausar",
        seguroPausarCompromiso: "¿Seguro que desea pausar compromiso?",
        seguroReanudarCompromiso: "¿Seguro que desea reanudar compromiso?",
        seguroAsignarAuditorResponsable: "¿Seguro que desea asignar un auditor responsable?",
        seguroQuitarAuditorResponsable: "¿Seguro que desea quitar un auditor responsable?",
        finalizado: "Finalizado",
        seguroDeseaFinalizarEstadoAdtCompromiso: "¿Estás seguro de que deseas finalizar los compromisos? Esta acción incluirá las aprobaciones restantes.",
        rechazarYdevolverAuditor: "Rechazar y devolver a auditor",
        devolverAuditor: "Devolver a auditor",
        camposAdicionales: "Campos adicionales",
        configurarCamposAdicionales: "Configurar campos adicionales",
        frecuenciaActualizacion: "Frecuencia de actualización",
        cantidadMeses: "Cantidad de meses",
        fechaActualizacion: "Fecha actualización",
        columnasGestionDocumentos: "Mostrar columnas de gestión en lista de documentos (Versión y Fecha actualización en reemplazo de Org. emisor y Estado)",
        semestral: "Semestral",
        opcional: "Opcional",
        debeAgregarPasoAlFlujo: "Debe agregar al menos un paso al flujo",
        todosLosPasoDebenTenerRol: "Todos los pasos deben tener un rol asignado",
        agregarPaso: "Agregar Paso",
        sinRolAsignado: "Sin rol asignado",
        seguroDeseaEliminarPlantillaFlujoTipoDoc: "¿Estás seguro que desea eliminar la plantilla de flujo para tipo de documento",
        etapa: "Etapa",
        prorrogaFinalizada: "Prórroga finalizada",
        porDefecto: "Por defecto",
        crearDocumento: "Crear documento",
        regenerarPdf: "Regenerar PDF",
        seguroDeseaRegenerarPdfUltimaVersion: "¿Estás seguro de que deseas regenerar PDF de última versión de documento?",
        incluirColGerencia: "Incluir columna gerencia",
        misSolicitudes: "Mis solicitudes",
        rechazaYdevuelveA: "Rechazar y devolver a",
        devuelveA: "Devolver a",
        plazoVencido: "Plazo vencido",
        ofiTotPlazoVenc: "Oficios totales con plazo de respuesta vencido",
        errorAlProcesarImagen: "Error al procesar imagen",
        vistaPrevia: "Vista previa",
        formaPago: "Forma de pago",
        formasPago: "Formas de pago",
        nuevaFormaPago: "Nueva forma de pago",
        controlCntFormaPago: "Control de formas de pago",
        listaCntFormasPago: "Lista de formas de pago",
        controlCntTipoRenovacion: "Control de tipos de renovación",
        listaCntTipoRenovacion: "Lista de tipos de renovación",
        nombreTipoRenovacion: "Nombre tipo de renovación",
        contratosEnRevision: "Contratos en revisión",
        tipoRenovacion: "Tipo de renovación",
        exigeFecha: "Exige fecha",
        nuevoTipo: "Nuevo tipo",
        nombreTipo: "Nombre tipo",
        fechaRenovacion: "Fecha renovacion",
        finanzas: "Finanzas",
        usuarioContratante: "Usuario contratante",
        controlCondicionesPago:"Control condiciones de pago",
        condicionPago: "Condición de pago",
        controlPenalizaciones: "Control de penalizaciones",
        listaPenalizaciones: "Lista de penalizaciones",
        nuevaPenalizacion: "Nueva penalización",
        penalizaciones : "Penalizaciones",
        renovarContrato: "Renovar contrato",
        renovar: "Renovar",
        finalizar: "Finalizar",
        porRenovar: "Por renovar",
        tipoContrato: "Tipo de contrato",
        revisionContrato: "Revisión de contrato",
        finalizarContrato: "Finalizar contrato",
        tiposRenovacion: "Tipos de renovación",
        nuevaFechaRenovacion: "Nueva fecha de renovación",
        sinArchivosCargados: "Sin archivos cargados",
        asistente: "Asistente",
        tipoEvaluacion: "Tipo evaluación",
        versionesAnteriores: "Versiones anteriores",
        modificarEstado: "Modificar estado",
        seguroDeseaCambiarEstado: "¿Estás seguro de que deseas cambiar el estado?",
        cntFormaEntrega: "Forma de entrega",
        glosaDescripcion: "Glosa o descripción",
        condicionesLiberacion: "Condiciones liberación",
        institucionEmisora: "Institución emisora",
        tipoBeneficiario: "Tipo de beneficiario",
        nroDocumento: "N° documento",
        fechaEmisionGarantia: "Fecha emisión",
        gestorGarantias: "Gestor de garantías",
        logo: "Logo",
        logoEmpresa: "Logo de la empresa",
        logoGlobal: "Logo global",
        configLogoGlobal: "Config. logo global",
        sinLogo: "Sin logo",
        cnfReportes: "Config. reportes",
        noFormatosDisponibles: "No hay formatos disponibles",
        notificarContraparte: "Notificar a contraparte",
        notificacion: "Notificación",
        sinAvisos: "Sin avisos",
        conversion: "Conversión",
        monedaOrigen: "Moneda de origen",
        monedaDestino: "Moneda destino",
        valorActualDestino: "Valor actual destino",
        valorRegistro: "Valor registro",
        evolucion: "Evolución",
        conversiones: "Conversiones",
        valorObservado: "Valor observado",
        sinConversionesDisponibles: "Sin conversiones disponibles",
        incidenciasPorCriticidad: "Incidencias por Criticidad",
        incidenciasPorEstado: "Incidencias por Estado",
        incidenciasPorOrganismoFalla: "Incidencias por Organismo de Falla",
        incidenciasPorPeriodo: "Incidencias por Período",
        incidencias: "Incidencias",
        estadosIncidencias: "Estados de incidencias",
        criticidadIncidencias: "Criticidad de incidencias",
        controlEstadoIncidencia: "Control de estados de incidencias",
        controlCriticidadIncidencia: "Control de criticidades de incidencias",
        listaEstadosIncidencias: "Lista de estados de incidencias",
        nuevoEstadoIncidencia: "Nuevo estado de incidencia",
        listaCriticidadesIncidencias: "Lista de criticidades de incidencias",
        nuevaCriticidadIncidencia: "Nueva criticidad de incidencia",
        habilitado: "Habilitado",
        color: "Color",
        selectorColor: "Selector de color",
        organismosFalla: "Organismos de falla",
        organismoFalla: "Organismo de falla",
        nuevoOrganismoFalla: "Nuevo organismo de falla",
        controlOrganismoFalla: "Control de organismos de falla",
        listaOrganismosFalla: "Lista de organismos de falla",
        servicios: "Servicios",
        controlServicios: "Control de servicios",
        listaServicios: "Lista de servicios",
        nuevoServicio: "Nuevo servicio",
        agentes: "Agentes",
        seleccionarServicios: "Seleccionar servicios",
        serviciosAsociados: "Servicios asociados",
        noHayServiciosAsociados: "No hay servicios asociados",
        incidenciasRelacionadas: "Incidencias Relacionadas",
        ticketInterno: "Ticket",
        nivelCriticidad: "Nivel de criticidad",
        accionesPreventivas: "Acciones preventivas",
        fechaImplementacion: "Fecha implementación",
        completada: "Completada",
        noAccionesPreventivas: "No se registran acciones preventivas",
        gestorIncidencias: "Gestor de incidencias",
        nuevaIncidencia: "Nueva incidencia",
        editarIncidencia: "Editar incidencia",
        activosAfectados: "Activos afectados",
        seleccioneEmpresaPrimero: "Seleccione una empresa primero",
        seleccionarActivos: "Seleccione uno o más activos afectados",
        confirmarEliminarIncidencia: "¿Está seguro que desea eliminar esta incidencia?",
        eliminarExitoso: "Eliminado exitosamente",
        noHayAccionesPreventivas: "No hay acciones preventivas registradas",
        accion: "Acción",
        agregarArchivos: "Agregar archivos",
        implementada: "Implementada",
        controlFirmasUsuarios: "Control firmas de usuario",
        listaFirmas: "Lista de firmas",
        firma: "Firma",
        sinFirma: "Sin firma",
        firmasUsuario: "Firmas de usuario",
        errorLimpiarFondoFirma: "Error limpiando fondo de firma",
        seguroPausarAuditoria: "¿Seguro que desea pausar auditoría?",
        seguroReanudarAuditoria: "¿Seguro que desea reanudar auditoría?",
        sinFormatosDisponibles: "No hay formatos disponibles.",
        modulosReportes: "Modulos de reportes",
        listaModulos: "Lista de módulos",
        formatoActualizadoExitoso: "Formato actualizado exitosamente",
        configurarMarcadores: "Configurar marcadores",
        clave: "Clave",
        obligatorio: "Obligatorio",
        valorPredeterminado: "Valor predeterminado",
        textoAyuda: "Texto de ayuda",
        marcadores: "Marcadores",
        marcadorActualizadoExitoso: "Marcador actualizado exitosamente",
        incluirProcesos: "Incluir Procesos",
        incluirActivos: "Incluir Activos",
        reporteContratos: "Reporte de contratos",
        controlesVencidos: "Controles vencidos",
        controlesFinalizados: "Controles finalizados",
        cuestionarioProveedor: "Cuestionario proveedor",
        detalleProveedor: "Detalle proveedor",
        dominiosPreguntas: "Dominios y preguntas",
        editarProveedor: "Editar proveedor",
        evaluacionAsignada: "Evaluación asignada",
        factoresRiesgoInherente: "Factores de riesgo inherente",
        gestorProveedores: "Gestor de proveedores",
        misEvaluacionesAsignadas: "Mis evaluaciones asignadas",
        misRevisiones: "Mis revisiones",
        misVisaciones: "Mis visaciones",
        nuevoProveedor: "Nuevo proveedor",
        razonSocial: "Razón social",
        configuracion: "Configuración",
        deshabilitado: "Deshabilitado",
        detalleModeloEvaluacion: "Detalle modelo de Evaluación",
        dominiosEvaluacion: "Dominios de Evaluación",
        editarModeloEvaluacion: "Editar modelo de evaluación",
        escala: "Escala",
        escalaMaxima: "Escala máxima",
        gestorModelosEvaluacion: "Gestor de modelos de evaluación",
        metodoResidual: "Método residual",
        nuevoModeloEvaluacion: "Nuevo modelo de evaluación",
        vigenciaDesde: "Vigencia desde",
        detalleEvaluacion: "Detalle evaluación",
        iniciarEvaluacion: "Iniciar evaluación",
        editarEvaluacion: "Editar evaluación",
        fechaEvaluacion: "Fecha evaluación",
        gestorEvaluacionesProveedores: "Gestor de evaluaciones proveedores",
        modelo: "Modelo",
        modeloEvaluacionRiesgo: "Modelo de Evaluación de riesgo",
        scoreControles: "Score controles",
        scoreInherente: "Score inherente",
        scoreResidual: "Score residual",
        validarFechaVencimientoEvaluacion: "La fecha de vencimiento no puede ser menor a la fecha de evaluaci?n",
        evaluador: "Evaluador",
        relacion: "Relación",
        activosRelacionados: "Activos relacionados",
        factor: "Factor",
        dominio: "Dominio",
        mapaProbabilidad: "Mapa de probabilidad",
        mapaImpacto: "Mapa de impacto",
        mapeoPuntajes: "Mapeo de puntajes",
        valorDesde: "Valor desde",
        valorHasta: "Valor hasta",
        valorMinimo: "Valor mínimo",
        valorMaximo: "Valor máximo",
        probabilidadIndex: "Índice probabilidad",
        impactoIndex: "Índice impacto",
        esCritica: "Es crítica",
        triggerTipo: "Tipo trigger",
        pesoPorcentaje: "Peso (%)",
        sumaActual: "Suma actual",
        validarPesoFactoresModeloEvalMenor: "La suma de los pesos de los factores de riesgo es menor a 100%",
        validarPesoFactoresModeloEvalMayor: "La suma de los pesos de los factores de riesgo es mayor a 100%",
        validarPesoDominiosModeloEvalMenor: "La suma de los pesos de los dominios es menor a 100%",
        validarPesoDominiosModeloEvalMayor: "La suma de los pesos de los dominios es mayor a 100%",
        validarPesoPreguntasDominioModeloEvalMayor: "La suma de los pesos de las preguntas del dominio no puede superar 100%",
        validarModeloEvalSinFactores: "Debe definir al menos un factor de riesgo",
        validarModeloEvalFactorSinOpciones: "Debe definir al menos una opción para el factor de riesgo",
        validarModeloEvalSinDominios: "Debe definir al menos un dominio de evaluación",
        validarModeloEvalDominioSinPreguntas: "Debe definir al menos una pregunta para el dominio",
        validarModeloEvalPreguntaSinOpciones: "Debe definir al menos una opción para la pregunta",
        proveedoresHabilitados: "Proveedores habilitados",
        proveedoresDeshabilitados: "Proveedores deshabilitados",
        proveedoresEvaluados: "Proveedores evaluados",
        proveedoresSinEvaluar: "Proveedores sin evaluar",
        evaluacionesTotales: "Evaluaciones totales",
        totalProveedores: "Total proveedores",
        evaluacionesEnRevision: "Evaluaciones en revisión",
        nivelRiesgoProveedores: "Nivel de riesgo de proveedores",
        riesgoResidualPromedio: "Riesgo residual promedio",
        riesgoPromedio: "Riesgo promedio",
        brecha: "Brecha",
        impactoProveedoresCriticos: "Impacto de proveedores críticos",
        evaluacionesEnCurso: "Evaluaciones en curso",
        evaluacionesVencidas: "Evaluaciones vencidas",
        riesgoAlto: "Riesgo alto",
        riesgoMedio: "Riesgo medio",
        riesgoBajo: "Riesgo bajo",
        estadosEvaluacion: "Estados de evaluación",
        procesosMasExpuestos: "Procesos más expuestos",
        activosCriticosAfectados: "Activos críticos afectados",
        riesgosAfectados: "Riesgos afectados",
        sinDatos: "Sin datos",
        ultimosIniciosSesion: "Últimos inicios de sesión",
        mostrarSoloUsuariosHabilitados: "Mostrar solo usuarios habilitados",
        agruparActividades: "Agrupar actividades",
        seguroDeseaReabrirIndicador: "¿Estás seguro de que deseas reabrir el indicador? Esta acción restablecerá el resultado.",
        cancelarSolicitud: "Cancelar solicitud",
        seguroDeseaCancelarSolicitud: "¿Estás seguro de que deseas cancelar la solicitud?",
        fechaInicioExt: "Fecha inicio",
        cancelar: "Cancelar",
        seguroDeseaCancelarOficio: "¿Estás seguro de que deseas cancelar el oficio?",
        cancelarOficio: "Cancelar oficio",
        cancelarExitoso: "Operación realizada con éxito. Elemento cancelado",
        compromisoProceso: "Compromiso / Proceso",
        procesoAsociado: "Proceso asociado",
        activosAsociados: "Activos asociados",
        configCierreIndicador: "Config. cierre de indicadores",
        ingreseDiasCierre: "Ingrese días de cierre",
        diasAntesFechaVencHabInd: "Días antes de la fecha de vencimiento se habilitará el indicador",
        paraRiesgos: "Para Riesgos",
        paraIndicadores: "Para Indicadores",
        paraEvRiesgos: "Para Ev. Riesgos",
        incluirRangoMeses: "Incluir rango meses",
        incluirResumenEjecutores: "Incluir resumen ejecutores",
        solicitudes: "Solicitudes",
        historialSolicitudes: "Historial de solicitudes",
        controlVersion: "Control de versión",
        observaciones: "Observaciones",
        rolEjecutor: "Rol ejecutor",
        verSolo: "Ver solo",
        cambiosEnDocumento: "Cambios en documento",
        cambiosDocumentoPlaceholder: "Ingrese los cambios en esta actualización",
        observacionesSolDocPlaceholder: "Ingrese comentarios y/o revisores de este documento",
        generaReporteCambios: "Reporte de cambios",
        cambiosActividades: "Cambios Actividades",
        cambiosControles: "Cambios Controles",
        gerenciaResponsable: "Gerencia responsable",
        sinCambios: "Sin cambios registrados",
        docsRelacionados: "Documentos relacionados",
        proveedor: "Proveedor",
        respuesta: "Respuesta",
        proveedores: "Proveedores",
        criticos: "Críticos",
        medios: "Medios",
        altos: "Altos",
        bajos: "Bajos",
        proporcional: "Proporcional",
        hibrido: "Híbrido",
        reduccionNivel: "Reducción nivel",
        periodoAReportar: "Periodo a reportar",
        placeholderPeriodoAReportar: "Fecha de cierre del indicador (mes anterior al actual)",
        aplicaResultado: "Aplica resultado",
        periodoReportado: "Periodo reportado",
        sinResultado: "Sin resultado",
        modificacionMasivaEstado: "Modificación masiva de estado",
        cancelada: "Cancelada",
        modificacionExitosaActividades: "Actividades modificadas exitosamente",
        cambioEstado: "Cambio de estado",
        seguroDeseaModificarEstados: "¿Estás seguro de que deseas modificar los estados?",
        seguroDeseaCancelarActividades: "¿Estás seguro de que deseas cancelar las actividades?",
        confirmar: "Confirmar",
        mostrarInformativos: "Mostrar informativos",
        filtrosAvanzados: "Filtros avanzados",
        controlDeficiente: "Control deficiente",
        requierePrerevisorAntes: "Requiere paso con rol Pre-revisor antes de continuar",
        requiereAlMenosUnPasoConPrerevisor: "Requiere al menos un paso con 'Requiere pre-revisor' activo antes del siguiente pre-revisor",
        debeSerRevisorOAprobador: "Requiere que tenga seleccionado revisor o aprobador antes de continuar",
        reporteSuperaMaximo: "El reporte supera los 350 elementos. Ingresa el rango que deseas incluir.",
        rangoMaximoElementos: "El rango no puede superar 350 elementos.",
        relacionGerenciaUsuario: "Relación gerencia/usuario",
        listaRelacionesGerenciaUsuario: "Lista de relaciones gerencia/usuario",
        reportaResultado: "Reporta resultado",
        fechaRespuesta: "Fecha respuesta",
        ocurrioErrInicioChat: "Ocurrió un error al inicializar el chat",
        chatbot: "Chatbot",
        limitesUso: "Límites de uso",
        controlAcceso: "Control de acceso",
        accesoChatbotUsuario: "Accesos chatbot/usuario",
        nuevoAcceso: "Nuevo acceso",
        historialConsultas: "Historial de consultas",
        consulta: "Consulta",
        consultasRealizadas: "Consultas realizadas",
        consultasRestantes: "Consultas restantes",
        cuotaDisponiblePeriodo: "Cuota disponible para el periodo",
        usoCuota: "Uso de cuota",
        fechaDeInicio: "Fecha de inicio",
        cuotas: "Cuotas",
        consultasTotales: "Consultas totales",
        gestorRequerimientos: "Gestor de requerimientos",
        nuevoRequerimiento: "Nuevo requerimiento",
        editarRequerimiento: "Editar requerimiento",
        requerimientos: "Requerimientos",
        seguroDeseaEliminarRequerimiento: "¿Estás seguro de que deseas eliminar el requerimiento",
        pendienteDeEnvio: "Pendiente de envío",
        respondidos: "Respondidos",
        devuelto: "Devuelto",
        ejecutorContraparte: "Ejecutor contraparte",
        categoriaRequerimientos: "Categorías de requerimientos",
        controlAdtCategoriaRequerimientos: "Control de categorías de requerimientos",
        listaAdtCategoriaRequerimientos: "Lista de categorías de requerimientos",
        misRequerimientos: "Mis requerimientos",
        marcarComoRespondido: "Marcar como respondido",
        responderRequerimiento: "Responder requerimiento",
        requerimientoCompletado: "Requerimiento completado",
        requerimientoSinTerminar: "Sin terminar",
        responder: "Responder",
        devueltos: "Devueltos",
        enviarAContraparte: "Enviar a contraparte",
        seguroDeseaEnviarRequerimientos: "¿Está seguro que desea enviar",
        seguroDeseaEnviarRequerimiento: "¿Está seguro que desea enviar el requerimiento",
        seguroDeseaCancelarRequerimiento: "¿Está seguro que desea cancelar el requerimiento",
        seguroDeseaAceptarRequerimiento: "¿Está seguro que desea aceptar el requerimiento",
        motivoCancelacion: "Motivo de cancelación",
        seguroDeseaDevolverRequerimiento: "¿Está seguro que desea devolver el requerimiento",
        motivoDevolucion: "Motivo de devolución",
        devolver: "Devolver",
        aceptarRequerimiento: "Aceptar requerimiento",
        aceptados: "Aceptados",
        aLaContraparte: "a la contraparte",
        enviarPetitorio: "Enviar Petitorio",
        seguroDeseaEnviarPetitorio: "¿Está seguro que desea enviar el petitorio? Se enviarán todos los requerimientos pendientes de esta auditoría.",
        enviarPetitorioExitoso: "Petitorio enviado exitosamente",
        distribucionPorEstado: "Distribución por estado",
        cambiarUmbrales: "Cambiar umbrales",
        indicadorPadre: "Indicador padre",
        periodoIndicador: "Periodo indicador",
        verSoloAtrasados: "Ver solo atrasados",
        verSoloAtrasadas: "Ver solo atrasadas",
        deshabilitaComentEjecutorVisador: "Deshabilita comentarios ejecutor/visador",
        prob: "Prob.",
        imp: "Imp.",
        cerradasATiempo: "Cerradas a tiempo",
        cerradasFueraPlazo: "Cerradas fuera de plazo",
        correspondePeriodoAnterior: "Corresponde al periodo anterior al vencimiento actual",
        deseaReportarResultado: "¿Desea reportar resultado para el periodo?",
        implementado: "Implementado",
        parcial: "Parcial",
        brechaRelevante: "Brecha relevante",
        avanceDominio: "Avance por dominio",
        estadoCritControles: "Estado de criterios de controles",
        nroTotalControles: "N° total de controles",
        avanceGlobal: "Avance global",
        controlesVisados: "Controles visados",
        porControles: "% de los controles",
        auditorQa: "Auditor QA",
        seguroDeseaReactivarControles: "¿Está seguro que desea reactivar los controles? De corresponder, se generará la próxima repetición a partir de la fecha actual.",
        tipoActas: "Tipo actas",
        nuevoTipoActa: "Nuevo tipo de acta",
        controlTiposActa: "Control de tipos de acta",
        listaTiposActa: "Lista de tipos de acta",
        nuevoTipoSesion: "Nuevo tipo de sesión",
        controlTiposSesion: "Control de tipos de sesión",
        listaTiposSesion: "Lista de tipos de sesión",
        reporteSolDocumentos: "Reporte solicitud de documentos",
        importacionMasivaJuicioExpResidual: "Importación masiva juicio exp. residual",
        agregarVersion: "Agregar versión",
        avisoDescuadreVersiones: "Versión no coincide",
        solicitudesFinalizadas: "Solicitudes finalizadas",
        fechaVersion: "Fecha versión",
        fechaYaExiste: "Ya existe una versión registrada con esa fecha",
        resumenEvalRiesgo: "Resumen eval. riesgo",
        gestorResumenEvaluacionRiesgo: "Gestor resumen de evaluación de riesgo",
        nuevoEventoRer: "Nuevo evento RER",
        editarEventoRer: "Editar evento RER",
        eventoRer: "Evento RER",
        debilidad: "Debilidad",
        interes: "Interés",
        conformidad: "Conformidad",
        comentarioConformidad: "Comentario de conformidad",
        conforme: "Conforme",
        noConforme: "No conforme",
        nuevaIteracion: "Nueva iteración",
        medioVerificacion: "Medio de verificación",
        fechaCierreReal: "Fecha de cierre real",
        planesAccionRer: "Planes de acción RER",
        resumenEvaluacionRiesgo: "Resumen evaluación riesgo",
        areasRer: "Áreas RER",
        prioridadesRer: "Prioridades RER",
        equiposRer: "Equipos RER",
        equipoRer: "Equipo RER",
        equipo: "Equipo",
        oficioAsocRer: "Oficio asociado a Resumen de Evaluación de Riesgo",
        bibliotecaSolDocumentos: "Biblioteca de solicitudes documentos",
        usuarioActual: "Usuario actual",
        reasignarSolicitudes: "Reasignar solicitudes",
        etiquetas: "Etiquetas",
        controlOfiEtiquetas: "Control etiquetas de oficio",
        listaEtiquetas: "Lista de etiquetas",
        nuevaEtiqueta: "Nueva etiqueta",
        deseaActualizarEtiquetas: "¿Desea actualizar etiquetas?",
        gestorAprobaciones: "Gestor de aprobaciones",
        enBorrador: "En borrador",
        cambiosEnBorrador: "Cambios en borrador",
        cambiosPendientesAprobacion: "Cambios pendientes de aprobación",
        anulados: "Anulados",
        tipoCambio: "Tipo de cambios",
        riesgoModificacion: "Riesgo / Modificación",
        codigoRiesgo: "Código riesgo",
        revisarRiesgo: "Revisar riesgo",
        revisarControl: "Revisar control",
        enviarARevision: "Enviar a revisión",
        seguroEnviarRevision: "¿Está seguro de enviar los cambios a revisión?",
        aprobado: "Aprobado",
        comentariosObservaciones: "Comentarios u observaciones",
        seguroAprobarSolicitud: "¿Está seguro que desea aprobar la solicitud?",
        seguroDevolverSolicitud: "¿Está seguro que desea devolver la solicitud?",
        evaluacionRiesgo: "Evaluación del riesgo",
        gestoresRiesgo: "Gestores de riesgos",
        duenoRiesgo: "Dueño del riesgo",
        propuesto: "Propuesto",
        anulado: "Anulado",
        enviarExitoso: "Enviado exitosamente",
        afectaProbabilidad: "Afecta probabilidad",
        afectaConsecuencia: "Afecta consecuencia",
        grupoEvaluacion: "Grupo de evaluación",
        calificacionProbabilidad: "Calificación de probabilidad",
        calificacionConsecuencia: "Calificación de consecuencia",
        reqInactivoReasignacion: "La funcionalidad se habilitará cuando la reasignación sea evaluada",
        solicitudReasignacion: "Solicitud de reasignación",
        noRequerimiento: "N° requerimiento",
        evaluacionExitosa: "Evaluación exitosa",
        enReasignacion: "En reasignación",
        importacionMasivaOfiEtiquetas: "Importación masiva etiquetas de oficios",
        ocurrencia: "Ocurrencia",
    }
};

export default es_localization;
